var title_product   = "";
var title_shipping  = "";
var title_total     = "";
var title_fees      = "";
var error_p         = "";
var single_product = null;
var sendOrder = false;
var link_pro = "";
var erro_p = "";

var country_code;
$.ajax({ 
    url: "//www.cloudflare.com/cdn-cgi/trace",
    type: "GET",
    data: {}, 
    beforeSend: function () { },
    success: function (res) {
        country_code            = res.replace(/(\r\n|\n|\r)/gm, "").split('loc=');
        country_code                = country_code[1].split('tls=');
        country_code                = country_code[0];
    },
    error: function (t) {
    }
}); 

$(function () {
    var isInstteled = true;
    window.admin = 'https://admin.codmonster.com';  
 
    $.ajax({ 
        url: window.admin + "/api/visite",
        type: "POST",
        data: {
            shop: Shopify.shop 
        }, 
        beforeSend: function () { },
        success: function (t) {
            if (typeof t.status === "number") {
                if (t.status === 0) {
                    console.log("none!!!")
                    $('.form-quick-form').css('display', 'none !important');
                    $('.product-in-stock').css('display', 'none');
                    $('.product-time').css('display', 'none');
                    $('.container-rd').css('display', 'none');
                    $('.tt-fixed-product-wrapper').css('display', 'none');
                    isInstteled = false;
                }
                return isInstteled;
            } else {
                if ( t.countries.includes(country_code) ) {
                    isInstteled = false;
                }
                let pathAll = window.location.pathname;
                const slug = pathAll.substring(pathAll.indexOf('products/') + 9);
                var optG = "";
                var opt = "";
                var optSelect = "";
                var variant = null;
                var product_id = null;
                var opt2 = "";
                var variant_cook = null;
                var myColors = {
                };
                $.getJSON("/products/" + slug + ".js", function (product) {
                    single_product = product;
                    let activeVar = single_product.variants[0]['option1'];
                    data(single_product.id, single_product.variants[0].available);
                    product_id = single_product.id;
                    variant = single_product.variants[0]['id'];
                    $('#input_variant').val(variant);
                    $('#product_id').val(product_id);
                    var arrayOpt0 = [];
                    let arrayOpt1 = [];
                    let arrayOpt2 = [];
                    $.each(single_product.variants, function (t, e) {
                        if (e.option1 == activeVar && e.available) {
                            arrayOpt1.push(e.option2);
                            arrayOpt2.push(e.option3);
                        }
                        if( t==0 ) {
                            let currency = Shopify.currency.active;
                            if( currency == "COP" ) {
                                currency = "$";
                            }
                            $('.sale-price').text( parseFloat((e.price/100), 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + ' '+currency ).attr('data-price', (e.price/100).toFixed(2)).attr('data-currency', currency)
                        }
                        if(e.available) {
                            avaiable_all = true;
                            arrayOpt0.push(e.option1);
                            let currency = Shopify.currency.active;
                            $(".product-in-stock span").text("18");
                        }
                        variant_cook = JSON.stringify(e);
                    });
                    if (single_product.options.length > 0) {
                        $.each(single_product.options, function (t, e) {
                            if (e.name != "Title") {
                                var number = t + 1;
                                opt += `
                                    <div class="tt-wrapper op-gen${number}">
                                    <div class="tt-title-options">
                                    ${e.name}: 
                                        <span class="name-op${number}"> 
                                        </span>
                                    </div>
                                    <ul class="tt-options-swatch options-large">
                                `;

                                optSelect += `
                                <div class="tt-wrapper op-gen${number}">
                                    <div class="tt-title-options">
                                    ${e.name}: 
                                        <span class="name-op${number}">
                                        </span>
                                    </div>
                                    <select class="drop-switch" name="option${number}" id="option${number}">
                                `;
                                if (e.position == 1) {
                                    let nameE = e.name;
                                    activeVar;

                                    $.each(e.values, function (t, e) {

                                        cp = -1;
                                        var t = t;
                                        if (nameE == 'Color') {
                                            let color = myColors[e.toLowerCase()];
                                            opt += `
                                                <li  data-availability="false">
                                                    <a class="options-selected  var-option${number}" data-option="option${number}" data-value="${e}">${e}</a>
                                                </li>
                                            `;
                                            optSelect += `
                                                <option value="${e}">${e}</option>
                                            `;
                                        } else { 
                                            if (activeVar == e) {
                                                opt += `
                                                    <li data-availability="false">
                                                        <a class="options-selected  var-option${number}" data-option="option${number}" data-value="${e}">${e}</a>
                                                    </li>
                                                `;
                                                optSelect += `
                                                    <option value="${e}">${e}</option>
                                                `;
                                            } else {
                                                opt += `
                                                    <li  data-availability="false">
                                                        <a class="options-selected  var-option${number}" data-option="option${number}" data-value="${e}">${e}</a>
                                                    </li>
                                                `;
                                                optSelect += `
                                                    <option value="${e}">${e}</option>
                                                `;
                                            }
                                        }

                                    });
                                } else {
                                    let nameE = e.name;
                                    activeVar;
                                    arrayOpt1;
                                    arrayOpt2;
                                    var arrA;
                                    if (e.position == 2) {
                                        arrA = arrayOpt1;
                                    } else {
                                        arrA = arrayOpt2;
                                    }
                                    $.each(e.values, function (t, e) {
                                        if (nameE == 'Color') {
                                            let color = myColors[e.toLowerCase()];
                                            opt += `
                                                <li  data-availability="false">
                                                    <a class="options-selected  var-option${number}" data-option="option${number}" data-value="${e}">${e}</a>
                                                </li>
                                            `;
                                            optSelect += `
                                                <option value="${e}">${e}</option>
                                            `;
                                        } else {
                                            if (arrA.includes(e)) {
                                                opt += `
                                                    <li data-availability="false">
                                                        <a class="options-selected  var-option${number}" data-option="option${number}" data-value="${e}">${e}</a>
                                                    </li>
                                                `;
                                                optSelect += `
                                                    <option value="${e}">${e}</option>
                                                `;
                                            } else { 
                                                opt += `
                                                    <li  data-availability="false">
                                                        <a class="options-selected var-option${number}" data-option="option${number}" data-value="${e}">${e}</a>
                                                    </li>
                                                `;
                                                optSelect += `
                                                    <option value="${e}">${e}</option>
                                                `;
                                            }
                                        }
                                    });
                                }
                                opt += "</ul></div>";
                                optSelect += `</select></div>`;
                            }
                        });
                        optG = `
                            <div class="tt-swatches-container tt-swatches-container-js mb-4">
                                ${opt}
                            </div>
                        `;
                        $('.tt-swatches-container-js').html(optG);
                    };
                });
                var opt1 = null;
                var opt2 = null;
                // $('#option1').on('change', function() {
                $(document.body).on('change',"#option1",function (e) {
                    var str = "";
                    opt1 = $(this).val();
                    $.each(single_product.variants, function (t, e) {
                        if (e.option1 == opt1 && e.available) {
                            variant = e.id;
                            $('#input_variant').val(variant);
                            str += "<option value='"+e.option2+"'>"+e.option2+"</option>";

                            let currency = Shopify.currency.active;
                            if( currency == "COP" ) {
                                currency = "$";
                            } else if(currency == "MAD") {
                                currency = "dh";
                            }
                            $('#ProductPrice-product-template').text(e.price/100 +' '+currency);
                            $('.sale-price').text( parseFloat((e.price/100), 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + ' '+currency ).attr('data-price', (e.price/100).toFixed(2)).attr('data-currency', currency);

                            setCookie("variant_cook", JSON.stringify(e), 1);
                            variant_cook = JSON.stringify(e);
                        }
                    });
                    $('#option2').html(str);
                });

                // $('#option2').on('change', function() {
                $(document.body).on('change',"#option2",function (e) {
                    opt2 = $(this).val();
                    $.each(single_product.variants, function (t, e) {
                        if (e.option2 == opt2 && e.option1 == opt1 && e.available) {
                            variant = e.id;
                            $('#input_variant').val(variant);

                            let currency = Shopify.currency.active;
                            if( currency == "COP" ) {
                                currency = "$";
                            } else if(currency == "MAD") {
                                currency = "dh";
                            }
                            $('#ProductPrice-product-template').text(e.price/100 +' '+currency);
                            $('.sale-price').text( parseFloat((e.price/100), 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + ' '+currency ).attr('data-price', (e.price/100).toFixed(2)).attr('data-currency', currency);

                            setCookie("variant_cook", JSON.stringify(e), 1);
                            variant_cook = JSON.stringify(e);

                        }
                    });
                });

                
                $(document).on("click", ".var-option1", function (event) {
                    let arrayTrue = [];
                    let arrayTrueTwo = [];
                    $('.var-option1').parent('li').removeClass('active');
                    $(this).parent('li').addClass('active');
                    opt1 = $(this).data('value');
                    $.each(single_product.variants, function (t, e) {
                        if (e.option1 == opt1 && e.available) {
                            variant = e.id;
                            $('#input_variant').val(variant);
                            $('.name-op1').text(e.option1);
                            $('.name-op2').text(e.option2);
                            $('.name-op3').text(e.option3);
                            arrayTrue.push(e.option2);
                            arrayTrueTwo.push(e.option3);     
                            let currency = Shopify.currency.active;
                            if( currency == "COP" ) {
                                currency = "$";
                            } else if(currency == "MAD") {
                                currency = "dh";
                            }
                            $('#ProductPrice-product-template').text(e.price/100 +' '+currency);
                            $('.sale-price').text( parseFloat((e.price/100), 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + ' '+currency ).attr('data-price', (e.price/100).toFixed(2)).attr('data-currency', currency);
                            let id_variant = $("[name=id]");
                            id_variant.val(variant);
                            setCookie("variant_cook", JSON.stringify(e), 1);
                            variant_cook = JSON.stringify(e);

                        }
                        $('.var-option2').parent('li').removeClass('active');
                        $('.var-option3').parent('li').removeClass('active');
                    });
                    $('.var-option2').map(function () {
                        if (arrayTrue.length > 0) {
                            $('.op-gen2').show();
                            if (arrayTrue.includes(String($(this).data('value')))) {
                                $(this).parent('li').show();
                            } else {
                                $(this).parent('li').hide();
                            }
                        } else {
                            $('.op-gen2').hide();
                            $('.name-op1').text("");
                        }
                    }).get();
                });

                var opt2 = null;
                $(document).on("click", ".var-option2", function (event) {
                    let arrayTrue = [];
                    $('.var-option2').parent('li').removeClass('active');
                    $(this).parent('li').addClass('active');
                    opt2 = $(this).data('value');
                    $.each(single_product.variants, function (t, e) {
                        if (e.option2 == opt2 && e.option1 == opt1 && e.available) {
                            variant = e.id;
                            $('#input_variant').val(variant);
                            $('.name-op2').text(e.option2);
                            arrayTrue.push(e.option3);
                            let currency = Shopify.currency.active;
                            if( currency == "COP" ) {
                                currency = "$";
                            } else if(currency == "MAD") {
                                currency = "dh";
                            }
                            let id_variant = $("[name=id]");
                            id_variant.val(variant);
                            $('#ProductPrice-product-template').text(e.price/100 +' '+currency);
                            $('.sale-price').text( parseFloat((e.price/100), 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + ' '+currency ).attr('data-price', (e.price/100).toFixed(2)).attr('data-currency', currency);
                            setCookie("variant_cook", JSON.stringify(e), 1);
                            variant_cook = JSON.stringify(e);

                        }
                        $('.var-option3').parent('li').removeClass('active');
                    });
                    $('.var-option3').map(function () {
                        if (arrayTrue.length > 0) {
                            $('.op-gen3').show();
                            if (arrayTrue.includes(String($(this).data('value')))) {
                                $(this).parent('li').show();
                            } else {
                                $(this).parent('li').hide();
                            }
                        } else {
                            $('.op-gen3').hide();
                            $('.name-op2').text("");
                        }
                    }).get();
                });

                var opt3 = null;
                $(document).on("click", ".var-option3", function (event) {
                    $('.var-option3').parent('li').removeClass('active');
                    $(this).parent('li').addClass('active');
                    opt3 = $(this).data('value');
                    $.each(single_product.variants, function (t, e) {
                        if (e.option3 == opt3 && e.option1 == opt1 && e.option2 == opt2) {
                            variant = e.id;
                            $('.name-op').text(e.option1);
                            $('#input_variant').val(variant);
                            let currency = Shopify.currency.active;
                            if( currency == "COP" ) {
                                currency = "$";
                            } else if(currency == "MAD") {
                                currency = "dh";
                            }
                            let id_variant = $("[name=id]");
                            id_variant.val(variant);
                            $('#ProductPrice-product-template').text(e.price/100 +' '+currency);
                            $('.sale-price').text( parseFloat((e.price/100), 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + ' '+currency ).attr('data-price', (e.price/100).toFixed(2)).attr('data-currency', currency);
                            setCookie("variant_cook", JSON.stringify(e), 1);
                            variant_cook = JSON.stringify(e);

                        }
                    });
                });

                var pathname = window.location.pathname;
                var pagePar = pathname.substring(1, 9);
                // if(window.location.toString().indexOf("products") != -1){
                //     console.log('eddd')
                // }
                // console.log(pathname);
                // console.log(pagePar);
                var val_stock = true;
                var ct_stock = '';
                if(val_stock) {
                    ct_stock = `
                        <div class="product-in-stock feature-info" style="color: #8908da;" lang="ar">
                            <div>
                                <span>21</span> Remaining product in stock
                            </div>
                            <div class="slide">
                                <div class="slide-inner" style="background: linear-gradient(270deg, #8908da 0, #570f85 100%);"></div>
                            </div>
                        </div>
                    `;
                } else {
                    ct_stock = ``;
                }
                var val_count = true;
                var ct_count = '';
                if(val_count) {
                    var ct_count = `
                        <div class="product-time"  lang="ar">
                            <p style="color:#8908da;">Buy now before it ends</p>
                            <input type="hidden" class="time-remain" value="&ctn" />
                            <div class="timer time1">
                                <div class="flex center" dir="ltr">
                                    <div class="item">
                                        <div style="color: #8908da;"
                                            class="number  days">00</div>
                                    </div>
                                    <span>:</span>
                                    <div class="item">
                                        <div style="color: #8908da;"
                                            class="number  hours">00</div>
                                    </div>
                                    <span>:</span>
            
                                    <div class="item">
                                        <div style="color: #8908da;"
                                            class="number  minutes">00</div>
        
                                    </div>
                                    <span>:</span>
            
                                    <div class="item">
                                        <div style="color: #8908da;"
                                            class="number  seconds animated infinite pulse duration-1s">00</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        `;
                }
                var val_qty = true;
                var ct_qty = '';
                link_pro = window.location.href;
                if(val_qty) {
                    var ct_qty = `
                        <div class="row justify-content-left" style="display: flex;">
                            <div class="qty-rd">
                                <button class="quantity__button__rd minus-btn" name="minus" type="button">
                                    -
                                </button>
                                <input class="quantity__input__rd" disabled type="text" name="quantity" min="1" value="1">
                                <button class="quantity__button__rd plus-btn" name="plus" type="button">
                                    +
                                </button>
                            </div>    
                        </div> 
                    `;
                }
                
                if( $('#landing_page').val() == "Isexist" ) {
                    $("#landing_page").after(`
                         ${ct_qty}
                    `);
                }

                if(  window.location.toString().indexOf("products") != -1 && isInstteled ){
                    $('.add-to-cart').css('display', 'none');
                    $("#codmonster , .product-single__add-to-cart, .add-to-cart").addClass('product-form');
                    var submit = $('.product-form').find(':submit').css('display', 'block');;
                    $('.product-single__add-to-cart').css('display', "none")
                    $(".product-form:first").after(`

                        ${ct_qty}

                        
                <div class="form-quick-form" lang="en" style="border: 2px solid #8908da;">
                    <p class="form-headline text-center" style="color: #191718 !important; font-size: 14px; font-weight: 600;"> 
                        Please fill this form to order this item!
                    </p> 
                    <input id="input_variant" type="hidden" value="" class="form-control">
                     
                <div class="inputGroup" data="1">
                    <input id="name" type="text" name="name"  placeholder="full name" value="" class="form-control-rd" required>
                    <span class="inputBar"></span>
                    <span id="error-name" class="error-msg" style="color: red;display: none; "></span>
                </div>
            
                <div class="inputGroup" data="2">
                    <input id="phone" type="tel" name="phone" placeholder="Phone number" value="" class="form-control-rd phone" required>
                    <span class="inputBar"></span>
                    <span id="error-msg" class="phone-error " style="color: red; display: none;"></span>
                    <span id="phone-error" style="color: red; display: none;"></span>
                </div>
            
                <div class="inputGroup" data="3">
                    <input id="city" type="text" name="city"  placeholder="City"  value="" class="form-control-rd" required>
                    <span class="inputBar"></span>
                    <span id="error-city" class="error-msg"   style="color: red;display: none;"></span>
                </div>
            
                <div class="inputGroup" data="4">
                    <input id="address" name="address"  placeholder="Address"  class="form-control-rd" rows="3" id="textareaMessage" required>
                    <span class="inputBar"></span>
                    <span id="error-address" class="error-msg"  style="color: red;display: none;"></span>
                </div>
            

                    <div class="shipping-sell-group-country">
                        <select name="country" id="country"></select>
                        <select class="hide" name="state-shipping" id="state-shipping"></select>
                    </div> 

                    <div class="cross-sell-group"></div>
                    <div class="shipping-sell-group">
                        <div class="shipping-items-group">
                        </div>
                        <input type="hidden" value="" id="rate_shipping" name="rate_shipping">
                    </div>

                    
            <div class="tt-price tt-price-last">
                <div class="tt-label-price">
                    <span class="label-price"></span>
                    <span class="sale-price" data-currency="" style="color: #8908da;"  >
                    </span>
                </div>
                <div class="tt-label-price shipping-detail hide">
                    <span class="label-price"></span>
                    <span class="price-shipping" data-shipping-price="0" style="color: #8908da;" ></span>
                </div>
                <div class="tt-label-price shipping-detail hide">
                    <span class="label-price"></span>
                    <span class="price-sh-tt" style="color: #8908da;" ></span>
                </div>
            </div>
        
                    
                    <button 
                        type="submit" 
                        class="btn btn-sticky-order btn-lg button addtocart-js2  shaking-btn" 
                        style="background: #8908da; color: #ffffff;" 
                        >
                            <div class="loader" style="display:none;"></div>
                            Buy now
                    </button>
                    
                    
                </div>
            

                        ${ct_stock}
                        ${ct_count}
        
                        <style>
                            .new-price-up-sell {
                                color: #8908da !important;
                            }
        
                            .icon__previous {
                                color: #8908da !important;
                            }
        
                            .icon__previous:hover {
                                opacity: 0.8;
                            }
        
                            body:not(.touch-device) ul.tt-options-swatch li:hover a:not(.options-color), ul.tt-options-swatch li.active a:not(.options-color) {
                                background: #8908da !important;
                                color: #fff;
                            }
        
                            .page-head .page-title {
                                color: #8908da !important;
                            }
        
                            .tt-wrapper .current_option_name {
                                color: #8908da !important;
                            }
        
                            ul.tt-options-swatch li .options-color:after {
                                border: 0 solid #8908da;
                            }
        
                            body:not(.touch-device) ul.tt-options-swatch li:hover a:not(.options-color), 
                            ul.tt-options-swatch li.active a:not(.options-color) {
                                background: #8908da;
                            }
                            
                            .upsell-img-active, 
                            .upsell-img:hover {
                                border: 2px solid #8908da;
                            }
        
                        </style>
                    `);
                    remplirCountry();
                }
                // ADD PRODUCTS TO CART
                async function addItemToCart(variant_id, qty, frequency, unit_type) {
                    let items;
                    let data = {
                        "id": variant_id,
                        "quantity": qty,
                        "properties": {
                            "shipping_interval_frequency": frequency,
                            "shipping_interval_unit_type": unit_type
                        }
                    }
                    await jQuery.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: data,
                        dataType: 'json',
                        success: function (data) {
                            items = data;
                        } 
                    });
                    return items;
                }
                var input = document.querySelector("#phone");
                var iti = window.intlTelInput(input, {
                    geoIpLookup: function (callback) {
                        $.ajax({
                            url: window.admin + "/api/geoip",
                            type: "POST",
                            data: { shop: Shopify.shop },
                            beforeSend: function () { },
                            success: function (t) {
                                var countryCode = (t && t.code) ? t.code : "";
                                callback(countryCode);
                                $('.sale-price').closest('.tt-label-price').find('.label-price').text(title_product);
                                $('.price-shipping').closest('.shipping-detail').find('.label-price').text(title_shipping);
                                $('.price-sh-tt').closest('.shipping-detail').find('.label-price').text(title_total);
                            },
                            error: function (t, e, i) { },
                        });
                    },
                    initialCountry: "auto",
                    utilsScript: $("#link_utils").val(),
                });
                var errorMsg = document.querySelector("#error-msg");
                var errorMap = ["", "Invalid country code", "Too short", "Too long", "Invalid number"];
                var reset = function () {
                    input.classList.remove("input-error");
                    errorMsg.innerHTML = "";
                    $('#error-msg').text('').val('');
                    errorMsg.classList.add("hide");
                    $('#error-msg').css('display', 'none');
                    $('#phone-error').text("");
                };

                input.addEventListener('blur', function () {
                    reset();
                    let numberPhone=input.value.trim();
                    if (iti.isValidNumber() ||
                        ( iti.selectedCountryData.dialCode=="60" && numberPhone.length>=10 ) ||
                        (   iti.selectedCountryData.dialCode=="212" && numberPhone.length==10 &&(numberPhone.startsWith('07')||numberPhone.startsWith('05')))) {
                        $('#error-phone').hide();
                        if (typeof getCookie("tmp_order_id") != "undefined" || typeof getCookie("order_id") != "undefined")
                            return false;
                        setCookie("tmp_order_id", null, 1)
                    } else {
                        input.classList.add("input-error");
                        var errorCode = iti.getValidationError();
                        errorMsg.style.color  = 'red';
                        errorMsg.style.display  = 'Block';
                        errorMsg.innerHTML = erro_p;
                        errorMsg.classList.remove("hide");
                        $('#error-phone').show();
                    }
                });
                // ABANDONAT ORDER
                var oldPhoneNumber = ''
                $(document.body).on('focusout', '#phone', function (e) {
                    if( !$("#phone").val() ) {
                        $('#phone-error').text('').show();
                    }
                    setTimeout(async function () {
                        if( sendOrder == false ) {
                            if ( $("#phone").val().length > 0 && $('#error-msg').text() === '' ) {
                                let id_variant = $("[name=id]");
                                await addItemToCart(id_variant.val(), 1, "1", "Months");
                                let items;
                                await jQuery.getJSON("/cart.js", function (t) {
                                    items = t.items[0];
                                });
                                if ($("#phone").val() !== oldPhoneNumber) {
                                    $('#phone-error').hide();
                                    oldPhoneNumber = $("#phone").val();
                                    let n = new FormData();
                                    n.append("name", ($("#name").val()?$("#name").val():''));
                                    n.append("phone", ($("#phone").val()?$("#phone").val():''));
                                    n.append("note", ($("#note").val()?$("#note").val():''));
                                    n.append("city", ($("#city").val()?$("#city").val():''));
                                    n.append("state", ($("#state").val()?$("#state").val():''));
                                    n.append("zipcode", ($("#zipcode").val()?$("#zipcode").val():''));
                                    n.append("address", ($("#address").val()?$("#address").val():''));
                                    n.append('store', Shopify.shop);
                                    n.append('quantity', 1);
                                    n.append('items', JSON.stringify(items));
                                    $('.addtocart-js2').prop('disabled', false);
                                    $.ajax({
                                        url: window.admin + "/api/abandoned",
                                        data: n,
                                        type: "POST",
                                        cache: !1,
                                        contentType: !1,
                                        processData: !1,
                                        success: function (t) {
                                            $.ajax({
                                                type: 'POST',
                                                url: '/cart/change.js',
                                                dataType: 'json',
                                                data: {
                                                    quantity: items['quantity'] - 1,
                                                    id: items['id']
                                                },
                                                success: function (data) { }
                                            });
                                            $('.addtocart-js2').prop('disabled', false);
                                            setCookie("currentOrderId", t.order_id, 1);
                                        },
                                        error: function (t, e, i) {
                                            $('.addtocart-js2').prop('disabled', false);
                                            console.log('error in abandonbed order request');
                                        },
                                    });
                                }
                            } else {
                                $('#phone-error').show();
                            }
                        }
                    }, 5000);
                });
                function zipcode_validate(zp) 
                { 
                    var regexPattern=new RegExp(/^[0-9-+]+$/);
                    return regexPattern.test(zp); 
                } 
                // CHECK PHONE NUMBER
                $(document.body).on('blur', '#confirmPhone', function () {
                    let phone = $('#phone').val();
                    let confirm_phone = $(this).val();
                    if (phone != confirm_phone) {
                        $('#error-msg-con').removeClass('hide');
                        $('#confirmPhone').css('border', '1px solid red');
                        $('#error-msg-con').html('');
                        $('.addtocart-js2').prop('disabled', true);
                    } else {
                        $('#error-msg-con').innerHTML = '';
                        $('#error-msg-con').addClass('hide');
                        $('#confirmPhone').css('border', 'none');
                        $('.addtocart-js2').prop('disabled', false);
                    }
                });
                $(document.body).on("change", "input[type=radio][name=up_sell]", async function () {
                    if ($(this).is(':checked')) {
                        let price = 0;
                        if ($(this).val() == "") {
                            $("#tt-price").html(getItemFormatedPrice(parseFloat(price)));
                            return false;
                        }
                        var t = $(this).val().split(",");
                        $("[name=quantity]").val(t[1]);
                        var $this = this;
                        var idVar = $('#input_variant').val();
                       if( variant_cook ) {
                            let variant_cok = JSON.parse(variant_cook);
                            price = variant_cok['price'] / 100;
                        }
                        let cross = $($this).val().split(",");
                        $("[name=quantity]").val(cross[1]);
                        var e = 0;
                        // "1" == cross[3]
                        //     ? (e = parseFloat(price) * parseInt(cross[1]) - parseFloat(cross[2]))
                        //     : "2" == cross[3]
                        //         ? (e = parseFloat(price) * parseInt(cross[1]) * (1 - parseFloat(cross[2]) / 100))
                        //         : ($("[name=quantity]").html(parseInt(cross[1]) + parseInt(cross[2])), (e = parseFloat(price) * parseInt(cross[1])));
                        var priceDiscount = 0;
                        if( "1" == cross[3] ) {
                            e = parseFloat(price) * parseInt(cross[1]) - parseFloat(cross[2]);
                            priceDiscount = parseFloat(cross[2]);
                            console.log( '1' );
                        } else if("2" == cross[3]) {
                            e = parseFloat(price) * parseInt(cross[1]) * (1 - parseFloat(cross[2]) / 100);
                            priceDiscount = parseFloat(price) * parseInt(cross[1]) * (parseFloat(cross[2]) / 100);
                        } else {
                            e = parseFloat(price) * parseInt(cross[1]) * (1 - parseFloat(cross[2]) / 100);
                            $("[name=quantity]").html(parseInt(cross[1]) + parseInt(cross[2])), (e = parseFloat(price) * parseInt(cross[1]));
                            priceDiscount = (1 - parseFloat(cross[2]) / 100);
                            console.log( '3' );
                        }
                        // START DISCOUNT VALUE DISPLAY
                      
                        $('.price-product').html( ( parseFloat(price) * parseInt(cross[1]) ) +' '+ Shopify.currency.active );
                        $('.price-crossel').html( '-' + priceDiscount +' '+ Shopify.currency.active );
                     
                        // END DISCOUNT VALUE DISPLAY   
                        var coupon_value = getCookie("coupon_value");
                        var coupon_type = getCookie("coupon_type");
                        if ( coupon_value != "null" ) {
                            if( coupon_type == 1 ) {
                                e = (parseFloat(e) - ((coupon_value*parseFloat(e))/100))*100;
                            } else if(coupon_type==2) {
                                e = (parseFloat(e) - coupon_value)*100;
                            }
                        }
 
                        $(".sale-price").html(e.toFixed(2) + ' ' + Shopify.currency.active).attr('data-price', e.toFixed(2));
                        let total = parseFloat($('.price-shipping').attr('data-shipping-price')) +  parseFloat(e.toFixed(2));
                        $(".price-sh-tt").html(total + ' ' + Shopify.currency.active);
                        $('.popup-price').html(e.toFixed(2));

                        return;
                    }
                });
                // GET DATA IN APP
                function data(product_id, qty) {
                    var i = product_id;
                    if (i) {
                        $.ajax({
                            url: "https://admin.codmonster.com/api/data",
                            type: "POST",
                            data: { product: i, shop: Shopify.shop },
                            beforeSend: function () { },
                            success: function (t) {
                                // on keyup / change flag: reset
                                /***********************Cross sell***************************************/
                                setCookie("coupon_value", "null", 1);
                                setCookie("coupon_type", "null", 1);
                                setCookie("coupon_id", "null", 1);

                                if ( !$.isEmptyObject(t.shipping) ) {
                                    localStorage.setItem('shipping', JSON.stringify(t.shipping));
                                    let isOne = true;
                                    t.shipping.forEach((item, index) => {
                                        if( item.isOneCountry != 1 ) {
                                            isOne = false;
                                        }
                                    }); 
                                    if( t.shipping.length==1 ) {
                                        if( t.shipping[0].isOneCountry == 1 ) {
                                            $('.shipping-title-only').text( t.shipping_title + ' ' + t.shipping[0].country['name'] );
                                            if( t.shipping[0].isAllStates == 1 ) {
                                                let rates = t.shipping[0].rates,
                                                codeL = '<div class="hr-crossel">'+ title_fees +'</div><div class="listing-form-check">';
                                                rates.forEach((item, index) => {  
                                                    let pricee = item['price']*100;
                                                    pricee = pricee/100 +' '+ $(".sale-price").attr('data-currency');
                                                    if( item['price'] == 0 ) {
                                                        pricee = '';
                                                    }
                                                    let check = '';
                                                    if( index == 0 ) {
                                                        let pro_price = $('.sale-price').attr('data-price');
                                                        let total = parseFloat(item['price'])+ parseFloat(pro_price);
                                                        $(".shipping-sell-group").show();
                                                        $('.shipping-detail').removeClass('hide').show();
                                                        let html = details_shipping_price(pro_price, item['price'], total, Shopify.currency.active);
                                                        $('.tt-price-last').html( html );
                                                        check = 'checked';
                                                        localStorage.setItem( 'shipping_rate', item['id'] );
                                                    }
                                                    codeL += `
                                                        <div class="form-check form-check-${index}" dir="ltl">
                                                            <input class="form-check-input shipping_rate" ${check} data-rate="${item['id']}" data-price="${item['price']}" id="shipping_rate_${item['id']}" value="${item['id']}"  type="radio" name="shipping_rate">
                                                            <label class="form-check-label" for="shipping_rate_${item['id']}">
                                                                <span class="label-text">
                                                                    ${item['name']} 
                                                                </span>
                                                                <span class="label-price">
                                                                    ${pricee} 
                                                                </span>
                                                            </label>
                                                        </div>
                                                    `;
                                                });
                                                $('.shipping-sell-group').show();
                                                codeL += '</div>';
                                                $(".shipping-items-group").html(codeL).show();
                                            } else {
                                                let status = '';
                                                status += `<option value=""></option>`;
                                                
                                                let states = t.shipping[0].states;
                                                states.forEach((item, index) => {  
                                                    if(item.state != null) {
                                                    status += `<option value="${ item.state['id'] }">${item.state['name']}</option>`;
                                                    }
                                                });
                                                $(".shipping-sell-group-country").show();
                                                $("#country").hide();
                                                $("#state-shipping").html(status).removeClass('hide').show();
                                            }
                                        } else {
                                            let status = '';
                                            $('#country').html('');
                                              $('.shipping-title-only').text( t.shipping_title + ' ' + t.shipping[0].country['name'] );
                                            if( t.shipping[0].isAllStates == 1 ) {
                                                let rates = t.shipping[0].rates,
                                                codeL = '<div class="hr-crossel">'+ title_fees +'</div><div class="listing-form-check">';
                                                rates.forEach((item, index) => {  
                                                    let pricee = item['price']*100;
                                                    pricee = pricee/100 +' '+ $(".sale-price").attr('data-currency');
                                                    if( item['price'] == 0 ) {
                                                        pricee = '';
                                                    }
                                                    let check = '';
                                                    if( index == 0 ) {
                                                        let pro_price = $('.sale-price').attr('data-price');
                                                        let total = parseFloat(item['price'])+ parseFloat(pro_price);
                                                        $(".shipping-sell-group").show();
                                                        $('.shipping-detail').removeClass('hide').show();
                                                        let html = details_shipping_price(pro_price, item['price'], total, Shopify.currency.active);
                                                        $('.tt-price-last').html( html );
                                                        check = 'checked';
                                                        localStorage.setItem( 'shipping_rate', item['id'] );
                                                    }
                                                    codeL += `
                                                        <div class="form-check form-check-${index}" dir="ltl">
                                                            <input class="form-check-input shipping_rate" ${check} data-rate="${item['id']}" data-price="${item['price']}" id="shipping_rate_${item['id']}" value="${item['id']}"  type="radio" name="shipping_rate">
                                                            <label class="form-check-label" for="shipping_rate_${item['id']}">
                                                                <span class="label-text">
                                                                    ${item['name']} 
                                                                </span>
                                                                <span class="label-price">
                                                                    ${ pricee } 
                                                                </span>
                                                            </label>
                                                        </div>
                                                    `;
                                                });
                                                $('.shipping-sell-group').show();
                                                codeL += '</div>';
                                                $(".shipping-items-group").html(codeL).show();
                                            } else {
                                                let status = '';
                                                status += `<option value=""></option>`;
                                                
                                                let states = t.shipping[0].states;
                                                states.forEach((item, index) => {  
                                                    if(item.state != null) {
                                                    status += `<option value="${ item.state['id'] }">${item.state['name']}</option>`;
                                                    }
                                                });
                                                $(".shipping-sell-group-country").show();
                                                $("#country").hide();
                                                $("#state-shipping").html(status).removeClass('hide').show();
                                            }
                                        }
                                    } else {
                                        if(isOne) {
                                            $('.shipping-title-only').text( t.shipping_title + ' ' + t.shipping[0].country['name'] );
                                            let isState = true;
                                            t.shipping.forEach((item, index) => {
                                                if( item.isAllStates != 1 ) {
                                                    isState = false;
                                                }
                                            });
                                            if( isState ) {
                                                let rates = t.shipping[0].rates,
                                                codeL = '<div class="hr-crossel">'+ title_fees +'</div><div class="listing-form-check">';
                                                rates.forEach((item, index) => {  
                                                    let pricee = item['price']*100;
                                                    pricee = pricee/100 +' '+ $(".sale-price").attr('data-currency');
                                                    if( item['price'] == 0 ) {
                                                        pricee = '';
                                                    }
                                                    let check = '';
                                                    if( index == 0 ) {
                                                        let pro_price = $('.sale-price').attr('data-price');
                                                        let total = parseFloat(item['price'])+ parseFloat(pro_price);
                                                        $(".shipping-sell-group").show();
                                                        $('.shipping-detail').removeClass('hide').show();
                                                        let html = details_shipping_price(pro_price, item['price'], total, Shopify.currency.active);
                                                        $('.tt-price-last').html( html );
                                                        check = 'checked';
                                                        localStorage.setItem( 'shipping_rate', item['id'] );
                                                    }
                                                    codeL += `
                                                        <div class="form-check form-check-${index}" dir="ltl">
                                                            <input class="form-check-input shipping_rate" ${check}" data-rate="${item['id']}" data-price="${item['price']}" id="shipping_rate_${item['id']}" value="${item['id']}"  type="radio" name="shipping_rate">
                                                            <label class="form-check-label" for="shipping_rate_${item['id']}">
                                                                <span class="label-text">
                                                                    ${item['name']} 
                                                                </span>
                                                                <span class="label-price">
                                                                    ${pricee} 
                                                                </span>
                                                            </label>
                                                        </div>
                                                    `;
                                                });
                                                $('.shipping-sell-group').show();
                                                codeL += '</div>';
                                                $(".shipping-items-group").html(codeL).show();
                                            } else {
                                                let status = '';
                                                status += `<option value=""></option>`;
                                                
                                                t.shipping.forEach((item, index) => {
                                                    item.states.forEach((item, index) => {  
                                                        if(item.state != null) {
                                                            status += `<option value="${ item.state['id'] }">${item.state['name']}</option>`;
                                                        }
                                                    })
                                                });
                                                $(".shipping-sell-group-country").show();
                                                $("#country").hide();
                                                $("#state-shipping").html(status).removeClass('hide').show();
                                            }
                                        }
                                        $(".shipping-sell-group-country").show();
                                    }
                                } else {
                                   localStorage.setItem('shipping', null);
                                }
                                var i = 1;
                                var n = t.cross_sells;
                                var dfn = null;
                                if (t.defaultCrossSell) {
                                    dfn = t.defaultCrossSell;
                                }
                                if (dfn != null && dfn.qty > 1) {
                                    $(".cross-sell-group").append(
                                        `<div class="item-cross-sell defaultCross">
                                                    <div class="form-check" dir="auto">
                                                        <input checked class="form-check-input" id="csRadio0" value="0,${dfn.qty},0,2"  type="radio" name="up_sell">
                                                            <label class="form-check-label" for="csRadio0">${dfn.msg}</label>
                                                    </div>
                                                </div`
                                    );
                                    $('.input-quantity').hide();
                                } else {
                                    $(".cross-sell-group").append(
                                        `<div class="item-cross-sell  defaultCross">
                                                    <div class="form-check" dir="auto">
                                                        <input checked  class="form-check-input" id="csRadio0" value="0,${dfn.qty},0,2"  type="radio" name="up_sell">
                                                            <label class="form-check-label" for="csRadio0">${dfn.msg}</label>
                                                    </div>
                                                </div`);
                                    if (n.length <= 0) {
                                        $('.defaultCross').hide();

                                    } else {
                                        $('.input-quantity').hide();
                                    }

                                }
                                n.forEach((e, index) => {
                                    if (e.type == 1) {
                                        let cross = e.msg.replace('[qty]', e.qty).replace('[value]', ` &nbsp;<span>${e.value + ' ' + Shopify.currency.active}</span> &nbsp;`)
                                        $(".cross-sell-group").append(
                                            `
                                                    <div class="item-cross-sell">
                                                        <div class="form-check" dir="auto">
                                                        <input class="form-check-input" type="radio" name="up_sell" id="csRadio${(index + 1)}" value="${e.id + ',' + e.qty + ',' + e.value + ',' + e.type}">
                                                        <label class="form-check-label" for="csRadio${index + 1}">${cross}
                                                            </label>
                                                        </div>
                                                    </div>
                                                `
                                        );
                                    }
                                    if (e.type == 2) {
                                        let cross = e.msg.replace('[qty]', e.qty).replace('[value]', ` &nbsp;<span>${e.value}%</span> &nbsp;`);
                                        $(".cross-sell-group").append(
                                            `
                                                        <div class="item-cross-sell">
                                                        <div class="form-check" dir="auto">
                                                            <input class="form-check-input" type="radio" name="up_sell" id="csRadio${(index + 1)}" value="${e.id + ',' + e.qty + ',' + e.value + ',' + e.type}">
                                                            <label class="form-check-label" for="csRadio${index + 1}">${cross}
                                                            </label>
                                                        </div>
                                                        </div>
                                                    `
                                        );
                                    }
                                    if (e.type == 3) {
                                        let cross = e.msg.replace('[qty]', e.qty).replace('[value]', ` &nbsp;<span>${e.value}</span> &nbsp;`);
                                        $(".cross-sell-group").append(
                                            `
                                                    <div class="item-cross-sell">
                                                    <div class="form-check" dir="auto">
                                                        <input class="form-check-input" type="radio" name="up_sell" id="csRadio${(index + 1)}" value="${e.id + ',' + e.qty + ',' + e.value + ',' + e.type}">
                                                        <label class="form-check-label" for="csRadio${index + 1}">${cross}
                                                        </label>
                                                    </div>
                                                    </div>
                                                    `
                                        );
                                    }
                                });
                                /***********************Cross sell***************************************/
                                /***********************Up sell***************************************/
                                var s = t.upsell;
                                0 == s.length && $(".upsell-container").hide(),
                                    $.ajax({
                                        url: "/products.json",
                                        type: "get",
                                        beforeSend: function () { },
                                        success: function (t) {
                                            //   console.log(t);
                                            if (localStorage.getItem("upsellSet") === null) {
                                                // console.log('upsell is set');
                                            }
                                            $.each(t.products, function (t, e) {
                                                s.forEach((t) => {
                                                    if (e.id == t.product_up) {
                                                        let option1Content = '';
                                                        let option1Variants = '';
                                                        let option2Content = '';
                                                        let option2Variants = '';
                                                        let optionValuesCheck = [];
                                                        let var2default = '';
                                                        let option3Content = '';
                                                        let option3Variants = '';
                                                        let var3default = '';
                                                        let iIndex = 0,
                                                            jIndex = 0,
                                                            kIndex = 0;
                                                        localStorage.setItem('upsellProduct', JSON.stringify(e));
                                                        setCookie('upsellProduct', JSON.stringify(e.variants));
                                                        // setCookie('upsellProductVariantId',JSON.stringify(e.variants));
                                                        let arrOpt = [];
                                                        if (e.options.length > 0) {
                                                            $.each(e.variants, (a, b) => {
                                                                if (b.available) {
                                                                    arrOpt.push(b.option1);
                                                                    setCookie("upsellsVariantId", b.id, 1);
                                                                    localStorage.setItem('upsellsVariantId', b.id);
                                                                }
                                                            });
                                                            if (e.options[0].values[0] != "Default Title") {
                                                                e.options[0].values.forEach((value, valueIndex) => {

                                                                    if (e.options[0].name === 'Color') {
                                                                        if ($.inArray(value, arrOpt) !== -1) {
                                                                            if (iIndex == 0) {
                                                                                option1Variants += `<li class="active var-option"><a href="#var-option0" class="options-color var-option0" data-value="${value}" data-tooltip="${value}" style="background:${value};"></a></li>`
                                                                                iIndex++;
                                                                            } else {
                                                                                option1Variants += `<li class="var-option"><a href="#var-option0" class="options-color var-option0" data-value="${value}" data-tooltip="${value}" style="background:${value};"></a></li>`
                                                                            }
                                                                        }
                                                                    } else {
                                                                        if ($.inArray(value, arrOpt) !== -1) {
                                                                            if (iIndex == 0) {
                                                                                option1Variants += `<li class="active  var-option"><a href="#var-option0" class="var-option0" data-value="${value}">${value}</a></li>`
                                                                                iIndex++;
                                                                            } else {
                                                                                option1Variants += `<li class="var-option"><a href="#var-option0" class="var-option0" data-value="${value}">${value}</a></li>`
                                                                            }
                                                                        }
                                                                    }
                                                                    localStorage.setItem('upsellsVariantId', e.variants[0].id);
                                                                });
                                                                option1Content = `<div class="tt-wrapper tt-wrapper-upsell my-3">
                                                                    <div class="tt-title-options">${e.options[0].name}: <span style="color: #00B43C" class="current_option_name current_option_name0">${e.options[0].values[0]}</span></div>
                                                                    <ul class="tt-options-swatch options-large options">
                                                                        ${option1Variants}
                                                                    </ul>
                                                                </div>`;
                                                            }
                                                            if (e.options.length >= 2) {
                                                                e.variants.forEach((variant, variantIndex) => {
                                                                    if (!optionValuesCheck.includes(variant.option2)) {
                                                                        if (variant.option1 === e.options[0].values[0] && e.options[1].name === 'Color' && jIndex == 0 && variant.available) {
                                                                            option2Variants += `<li class="active var-option"><a href="#var-option1" class="options-color var-option1" data-value="${variant.option2}" data-tooltip="${variant.option2}" style="background:${variant.option2};"></a></li>`
                                                                            var2default = variant.option2;
                                                                            optionValuesCheck.push(variant.option2);
                                                                            jIndex++;
                                                                        } else if (variant.option1 === e.options[0].values[0] && e.options[1].name === 'Color' && variant.available) {
                                                                            option2Variants += `<li class="var-option"><a href="#var-option1" class="options-color var-option1" data-value="${variant.option2}" data-tooltip="${variant.option2}" style="background:${variant.option2};"></a></li>`
                                                                            optionValuesCheck.push(variant.option2);
                                                                        } else if (variant.option1 === e.options[0].values[0] && jIndex == 0 && variant.available) {
                                                                            option2Variants += `<li class="active  var-option"><a href="#var-option1" class="var-option1" data-value="${variant.option2}">${variant.option2}</a></li>`
                                                                            var2default = variant.option2;
                                                                            optionValuesCheck.push(variant.option2);
                                                                            jIndex++;
                                                                        } else if (variant.option1 === e.options[0].values[0] && variant.available) {
                                                                            option2Variants += `<li class="var-option"><a href="#var-option1" class="var-option1" data-value="${variant.option2}">${variant.option2}</a></li>`
                                                                            optionValuesCheck.push(variant.option2);
                                                                        }
                                                                    }


                                                                })
                                                                option2Content = `<div class="tt-wrapper tt-wrapper-upsell my-3">
                                                                <div class="tt-title-options">${e.options[1].name}: <span style="color: #00B43C" class="current_option_name current_option_name1">${var2default}</span></div>
                                                                <ul class="tt-options-swatch options-large options1">
                                                                    ${option2Variants}
                                                                </ul>
                                                            </div>`;
                                                                if (e.options.length >= 3) {
                                                                    e.variants.forEach((variant, variantIndex) => {
                                                                        if (variant.option1 === e.options[0].values[0] && variant.option2 === var2default && e.options[2].name === 'Color' && kIndex == 0 && variant.available) {
                                                                            option3Variants += `<li class="active var-option"><a href="#var-option2" class="options-color var-option2" data-value="${variant.option2}" data-tooltip="${variant.option3}" style="background:${variant.option3};"></a></li>`
                                                                            var3default = variant.option3;
                                                                            kIndex++
                                                                        } else if (variant.option1 === e.options[0].values[0] && variant.option2 === var2default && e.options[2].name === 'Color' && variant.available) {
                                                                            option3Variants += `<li class="var-option"><a href="#var-option2" class="options-color var-option2" data-value="${variant.option3}" data-tooltip="${variant.option3}" style="background:${variant.option3};"></a></li>`
                                                                        } else if (variant.option1 === e.options[0].values[0] && variant.option2 === var2default && kIndex == 0 && variant.available) {
                                                                            option3Variants += `<li class="active  var-option"><a href="#var-option2" class="var-option2" data-value="${variant.option3}">${variant.option3}</a></li>`
                                                                            var3default = variant.option3;
                                                                            kIndex++
                                                                        } else if (variant.option1 === e.options[0].values[0] && variant.option2 === var2default && variant.available) {
                                                                            option3Variants += `<li class="var-option"><a href="#var-option2" class="var-option2" data-value="${variant.option3}">${variant.option3}</a></li>`
                                                                        }

                                                                    });
                                                                    option3Content = `<div class="tt-wrapper tt-wrapper-upsell my-3">
                                                                <div class="tt-title-options">${e.options[2].name}: <span style="color: #00B43C" class="current_option_name current_option_name2">${var3default}</span></div>
                                                                <ul class="tt-options-swatch options-large options2">
                                                                    ${option3Variants}
                                                                </ul>
                                                            </div>`;
                                                                }
                                                            }
                                                            let images = '';
                                                            let imgs = '';
                                                            e.images.forEach((image, index) => {

                                                                if (index == 0) {
                                                                    images += `
                                                    <div class="col-3">
                                                        <img  src="${image.src}"
                                                        class="rounded mx-auto d-block upsell-img upsell-img-active" alt="..."/>
                                                    </div>
                                                    `
                                                                    imgs += `<li>
                                                        <img  src="${image.src}"
                                                        class="rounded mx-auto d-block upsell-img upsell-img-active" alt="..."/>
                                                    </li>`
                                                                } else {
                                                                    imgs += `
                                                    <li>
                                                        <img  src="${image.src}"
                                                        class="rounded mx-auto d-block upsell-img" alt="..."/>
                                                            </li>
                                                    `
                                                                }

                                                            });

                                                            $(".list-upsell").html(

                                                                `
                                        <input type="hidden" id="productUrl" value="${e.handle}">
                                        <div class="container1-item1 product-details">
                                                <div class="row">
                                                    <div class="col-12">
                                                        </div>
                                                        <div class="col-12 my-2">
                                                        <h1 class="tt-title tt-title-upsell upsell-product-title">${e.title}</h1>
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="product-review product-review-upsell"><div class="rev-stars"><i class="icon-h-14"></i><i class="icon-h-14"></i><i class="icon-h-14"></i><i class="icon-h-14"></i><i class="icon-h-14"></i></div></div>
                                                    </div>
                                                    <div class="col-12">
                
                                                                <div class="tt-price tt-price-upsell" style="font-size: 30px">
                                                                    <span  class="new-price new-price-up-sell"></span>
                                                                    <span style="text-decoration: line-through" class="old-price old-price-up-sell">${e.variants[0].price}<span>${' ' + Shopify.currency.active}</span></span>
                                                                </div>
                                                    </div>
                                                    <div class="col-12 my-1">
                                                            ${option1Content}
                                                            ${option2Content}
                                                            ${option3Content}
                                                    </div>
                                                        <div class="col-12 my-1">
                                                            <button class="btnc shaking-btn btn-block btn-lg" id="addToOrder" style="background: #8908da;">
                                                                <div class="loader loading-upsell" style="display:none;"></div>
                                                                Add to order
                                                                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                                            </button>
                                                        </div>
                                                        <div class="col-12 my-1">
                                                                <button class="btnc shaking-btn btn-block btn-lg" id="noThankYou"  style="background: #f1f4f8 !important; color: #8908da;">
                                                                    No thanks
                                                                </button>
                                                        </div>
                                                </div>
                
                                        </div>
                                            <div class="container1-item2 product-images">
                                                <div class="img-prin">
                                                    <img id="current-upsell-img"
                                                        src="${e.images[0].src}"
                                                        style="width:300px;height: 300px"
                                                        class="rounded mx-auto"
                                                        alt="..."/>
                
                                                </div>
                                                <div class="img-scroller">
                                                    <ul id="scroller">
                                                        ${imgs}
                                                    </ul>
                                                    <a class="icon-img icon__previous btn-left"></a>
                                                    <a class="icon-img icon__next btn-right"></a>
                                                    </div>
                                            </div>
                                        `
                                                            );
                                                        }

                                                    }

                                                });
                                            });
                                        },
                                        error: function (t, e, i) { },
                                    });

                                /***********************Up sell***************************************/
                                // STATISTIQUE REVIEWS
                                t.reviewsStatic.forEach((rr) => {
                                    $('#r-' + rr.rate).css('width', ((rr.total * 100) / t.count).toFixed(2) + '%');
                                    $('#pr-' + rr.rate).html(rr.total);
                                })
                                // on keyup / change flag: reset
                                $(".list-reviews").html("");
                                var i = 1;
                                t.reviews.forEach((t) => {
                                    let tt_img;
                                    let tt_rate = '';
                                    if (t.image) {
                                        tt_img = '<img class="lazyload" src="https://admin.codmonster.com/storage/' + t.image + '">';
                                    } else {
                                        tt_img = '<img class="lazyload" src="https://admin.codmonster.com/storage/default-reviews.png">';
                                    }
                                    if (t.rate) {
                                        for (let index = 0; index < 5; index++) {
                                            if (t.rate > index) {
                                                tt_rate += '<span class="etoile" id="1" style="color: gold;">★</span>';
                                            } else {
                                                tt_rate += '<span class="etoile" id="1">★</span>';
                                            }
                                        }
                                    } else {
                                        tt_rate = '';
                                    }
                                    1 == i && ($(".call-to-action2").show(), $(".title-reviews").show()),
                                        $('.list-reviews').append(`
                                                    <div class="col-6 col-md-3 tt-col-item item-${i}"> 
                                                        <div class="item-review">   
                                                            <div class="respimgsize">
                                                                <div class="tt-image-box">
                                                                    ${tt_img}
                                                                    <div class="reviews-stars">
                                                                        <div class="rev-stars">
                                                                        ${tt_rate}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="rev-details">
                                                                    <div class="review_name">
                                                                        ${t.customer}
                                                                        <span class="icon">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20.898 20.898"><defs><style>.a{fill:#2196f3;}.b{fill:#fafafa;}</style></defs><path class="a" d="M10.449,0A10.449,10.449,0,1,0,20.9,10.449,10.46,10.46,0,0,0,10.449,0Zm0,0"/><path class="b" d="M151.3,166.815l-5.66,5.66a.87.87,0,0,1-1.231,0l-2.83-2.83a.871.871,0,1,1,1.231-1.231l2.214,2.214,5.044-5.044a.871.871,0,0,1,1.231,1.231Zm0,0" transform="translate(-135.56 -158.58)"/></svg>
                                                                        </span>
                                                                    </div>
                                                             
                                                                    <div class="tt-title"> 
                                                                        ${t.feedback}
                                                                    </div> 
                                                                </div>
                                                            </div>                                
                                                        </div>                            
                                                    </div>
                                                `);
                                    i++;
                                });
                            },
                            error: function (t, e, i) { },
                        });
                    }

                    // QAANTITY STOCK
                    $.ajax({
                        url: window.admin + "/api/quantity",
                        type: "POST",
                        data: {
                            shop: Shopify.shop,
                            product_id: product_id
                        },
                        success: function (t) {
                          qty = t.quantity;
                          var n = parseInt( $(".product-in-stock span").text(qty) );
                          $(".product .slide-inner").css("width", 3 * n + "%"),
                            (function (t) {
                            var e = t,
                                i = setInterval(function () {

                                }, 5e3);
                          })(n);
                            $(".product-in-stock span").text(t.quantity) 
                        },
                        error: function () {
                        },
                    });

                }
                //---------------------------------------------------------
                //  CLICK BUTTON QUICK ORDER
                //---------------------------------------------------------
                $("body").on("click", ".addtocart-js2", function (e) {
                    e.preventDefault();
                    Shopify.clear();
                    let qty = 1;
                    if( $('input[name=quantity]').val() ) {
                        qty = $('input[name=quantity]').val();
                    }
                    sendOrder = true;
                    if( $('#phone-error').text() !== '' ) {
                        $('#phone-error').hide();
                        return;
                    }
                    if( $('#error-msg').text() !== '' ) {
                        return;
                    }

                    if($('#zipcode').val()) {
                        // if( !zipcode_validate( $('#zipcode').val() ) || $('#zipcode').val().length > 10 ) {
                        //     $('#error-zipcode-val').show();
                        //     return;
                        // }
                    }
      
                    if(
                        ( $('#phone').prop('required') && !$('#phone').val() ) ||
                        ( $('#name').prop('required') && !$('#name').val() ) ||
                        ( $('#city').prop('required') && !$('#city').val() ) ||
                        ( $('#address').prop('required') && !$('#address').val() ) ||
                        ( $('#state').prop('required')  && !$('#state').val() ) ||
                        ( $('#zipcode').prop('required')  && !$('#zipcode').val() )
                    ){
                        if( $('#phone').prop('required') &&!$('#phone').val() ){
                            $('#phone-error').show().text(''); 
                        } else {
                            $('#phone-error').hide();
                        }
                        if( $('#name').prop('required') &&!$('#name').val() ){
                            $('#error-name').show().text('');
                        } else {
                            $('#error-name').hide();
                        }
                        if( $('#city').prop('required') && !$('#city').val()){
                            $('#error-city').show().text('');
                        } else {
                            $('#error-city').hide();
                        }
                        if( $('#address').prop('required') && !$('#address').val()){
                            $('#error-address').show().text('');
                        } else {
                            $('#error-address').hide();
                        }
                        if( $('#state').prop('required') && !$('#state').val() ){
                            $('#error-state').show().text('');
                        } else {
                            $('#error-state').hide();
                        }
                        if( $('#zipcode').prop('required') && !$('#zipcode').val() ){
                            $('#error-zipcode').show().text('');
                        } else {
                            $('#error-zipcode').hide();
                        }
                        return;
                    } else{
                        let id_variant = $("[name=id]");
                        if( id_variant.val() ) {
                            if( $('#landing_page').val() == "Isexist" ) {
                            }else {
                                var rr = Shopify.addItemFromForm( id_variant.val(), qty );
                            }
                          } else {
                            let id_variant = $("#input_variant");
                            if( $('#landing_page').val() == "Isexist" ) {
                            }else {
                              var rr = Shopify.addItemFromForm( id_variant.val(), qty );
                            }
                        }
                    }

                });
                //---------------------------------------------------------
                //  CLICK CLOSE POPUP THANK YOU PAGE
                //---------------------------------------------------------
                $(document.body).on('focusout', '#name', function (e) {
                    if( $('#name').prop('required') && !$('#name').val() ){
                        $('#error-name').show().text('');
                    } else {
                        $('#error-name').hide();
                    }
                });
                $(document.body).on('focusout', '#state', function (e) {
                    if( $('#state').prop('required') && !$('#state').val() ){
                        $('#error-state').show().text('');
                    } else {
                        $('#error-state').hide();
                    }
                });
                $(document.body).on('focusout', '#address', function (e) {
                    if( $('#address').prop('required') && !$('#address').val() ){
                        $('#error-address').show().text('');
                    } else {
                        $('#error-address').hide();
                    }
                });
                $(document.body).on('focusout', '#city', function (e) {
                    if( $('#city').prop('required') && !$('#city').val() ){
                        $('#error-city').show().text('');
                    } else {
                        $('#error-city').hide();
                    }
                });
                //---------------------------------------------------------
                //  CLICK CLOSE POPUP THANK YOU PAGE
                //---------------------------------------------------------
                $("body").on("click", ".close", function (e) {
                    $('#modalThankYouPage').hide();
                    location.reload();
                });
                //---------------------------------------------------------
                //  REMOVE REQUIRED
                //---------------------------------------------------------
                $('.add-card-r').on('click', function () {
                    $('#name').removeAttr('required');
                    $('#phone').removeAttr('required');
                    $('#city').removeAttr('required');
                    $('#address').removeAttr('required');
                    $('#country').removeAttr('required');
                    $('#state').removeAttr('required');
                    $('#zipcode').removeAttr('required');
                    $('#confirmPhone').removeAttr('required');
                    $('#note').removeAttr('required');
                });
                //---------------------------------------------------------
                //  ADD ITEM FROM IN CARRT
                //---------------------------------------------------------
                Shopify.addItemFromForm = function (variant_id, quantity, callback) {
                    var params = {
                        type: "POST",
                        url: "/cart/add.js",
                        data: "quantity=" + quantity + "&id=" + variant_id,
                        dataType: "json",
                        success: function (line_item) {
                            var i = new FormData();
                            var htmlcart = "";
                            var items = line_item;
                            jQuery.getJSON("/cart.js", function (t) {
                                var n = new FormData();
                                var itemss = [];
                                itemss.push(items);
                                t['items'] = itemss;
                                n.append("form_type", 'product');
                                n.append("id", variant_id);
                                n.append("quantity", $('input[name=quantity]').val());
                                n.append("name",  ($("#name").val()?$("#name").val():''));
                                n.append("phone",  ($("#phone").val()?$("#phone").val():''));
                                n.append("note", ($("#note").val()?$("#note").val():''));
                                n.append("city", ($("#city").val()?$("#city").val():''));
                                n.append("state", ($("#state").val()?$("#state").val():''));
                                n.append("zipcode", ($("#zipcode").val()?$("#zipcode").val():''));
                                n.append("address", ($("#address").val()?$("#address").val():''));
                                n.append("suffex", $('.iti__selected-flag').attr('title') );
                                n.append("up_sell", $('input[name=up_sell]:checked').val());
                                n.append("shop", Shopify.shop);
                                n.append("currentOrderId", getCookie("currentOrderId")),
                                n.append("data", JSON.stringify(t));
                                n.append("shipping_rate", localStorage.getItem( 'shipping_rate' ));
                                n.append("coupon_id", getCookie("coupon_id"));
                                $(".loader").show();
                            
                                $.ajax({
                                    url: window.admin + "/api/order",
                                    data: n,
                                    type: "POST",
                                    cache: !1,
                                    contentType: !1,
                                    processData: !1,
                                    beforeSend: function () {
                                        $(".loader").show();
                                    },
                                    success: function (t) {
                                        $('#phone').val('');
                                        $(".btn-quick-form").prop("disabled", !1);

                                        localStorage.setItem('order_status_url', null);
                                        localStorage.setItem('order_status_url', t.order_status_url);
                                        window.dataLayer = window.dataLayer || [];
                                        dataLayer.push({
                                            'currencyCode': Shopify.currency.active,
                                            'transactionTotal': meta.product.variants[0].price / 100
                                        });

                                        (typeof ga === "function") ? ga('send', { hitType: 'event', eventCategory: 'Products', eventAction: meta.product.variants[0].name, eventLabel: meta.product.variants[0].price / 100 }) : null,
                                            
                                        // (typeof fbq === "function") ? fbq('track', 'Purchase', { currency: Shopify.currency.active, value: meta.product.variants[0].price / 100 }) : null,
                                        (typeof fbq === "function") ? fbq('track', t.event.eventName!=null?t.event.eventName:'Purchase', {
                                            currency:t.event.currency!=null?t.event.currency:Shopify.currency.active,
                                            value:t.event.price!=null?t.event.price:meta.product.variants[0].price / 100
                                            },{eventID:t.event.eventId!=null?t.event.eventId:new Date().getTime()}) : null;
        
                                        (typeof snaptr === "function") ? snaptr('track', 'PURCHASE', { 'currency': Shopify.currency.active == 'OMR' ? 'USD' : Shopify.currency.active, 'price': Shopify.currency.active == 'OMR' ? (meta.product.variants[0].price / 100 * 2.6).toFixed(2) : (meta.product.variants[0].price / 100).toFixed(2), 'item_category': '', 'item_ids': '' }) : null,
                                            
                                        (typeof ttq == "object") ? ttq.track('CompletePayment',{content_type:'product', content_id: t.order_id,quantity: 1, price: meta.product.variants[0].price / 100,value: meta.product.variants[0].price / 100,currency: Shopify.currency.active,}): null,

                                        Shopify.clear();

                                        setCookie("order_id", t.order_id, 1), setCookie("upsells", JSON.stringify(t.upsells), 1);
                                        t.order_status_url = "";
                                        setCookie("upsellsAndOrder", JSON.stringify(t), 1);
                                        setCookie("upsellsVariantId", t.product_up, 1);
                                        setCookie("id_order_shopify", t.id_order_shopify, 1);
                                        if (t.upsells.length <= 0) {
                                            let order_status_url = localStorage.getItem("order_status_url");
                                            if( order_status_url != "null"  ) {
                                                window.location.replace(order_status_url);
                                            } else {
                                                $(".loader").hide();
                                                
                                                $("#modalThankYouPage").css('display', 'flex');
                                                $("#modalThankYouPage").css('visibility', 'visible');
                                                $(".msg-promo").text("");
                                                $('.upsell-container').addClass('d-none');
                                                $('.upsell-container').css('display', 'none');
                                                $('.modal-dialog').addClass('modal-dialog-thank');
                                            }
                                            return false;
                                        } else {
                                            $(".loader").hide();
                                            $("#modalThankYouPage").css('display', 'flex');
                                            $("#modalThankYouPage").css('visibility', 'visible');
                                            $('.page-head').css('display','none').addClass('d-none');
                                            (t.upsells[0].discount == 0) ? $(".msg-promo").text("") :
                                                $(".msg-promo").text($(".msg-promo").text().replace("[discount]", (t.upsells.length) ? t.upsells[0].discount : 0));
                                            /*let oldPrice = parseFloat($('.old-price-up-sell').text())
                                            $('.new-price-up-sell').html(`${(oldPrice-(oldPrice*t.upsells[0].discount/100)).toFixed(2)}<span>${' '+Shopify.currency.active}</span>`);*/
                                            let oldPrice = 0;
                                            if (t.prix) {
                                                oldPrice = parseInt(t.prix);
                                                $('.new-price-up-sell').html(`${(oldPrice - (oldPrice * t.upsells[0].discount / 100)).toFixed(2)} <input id="discount" name="discount" type="hidden" value="${t.upsells[0].discount}"> <span>${' ' + t.currency_conv}</span>`);
                                                $('.old-price-up-sell').html(`${oldPrice}<span>${' ' + t.currency_conv}</span>`);
                                            } else {
                                                oldPrice = parseFloat($('.old-price-up-sell').text());
                                                $('.new-price-up-sell').html(`${(oldPrice - (oldPrice * t.upsells[0].discount / 100)).toFixed(2)} <input id="discount" name="discount" type="hidden" value="${t.upsells[0].discount}"> <span>${' ' + Shopify.currency.active}</span>`);
                                            }
                                        }

                                    },
                                    error: function (t, e, i) {
                                        $("#quick-form .add-to-cart").prop("disabled", !1), $("#loading-atc").hide();
                                    }
                                });

                            });
                        },
                        error: function (XMLHttpRequest, textStatus) { },
                    };
                    jQuery.ajax(params);
                };
                //-------------------------------------------------------------------------------------
                //  FUNCTIO CLEAR CART IN SHOPPIFY
                //-------------------------------------------------------------------------------------
                (Shopify.clear = function (t) {
                    var e = {
                        type: "POST",
                        url: "/cart/clear.js",
                        data: "",
                        dataType: "json",
                        success: function (e) {

                        },
                        error: function (t, e) {
                            Shopify.onError(t, e);
                        },
                    };
                    jQuery.ajax(e);
                });
                //-------------------------------------------------------------------------------------
                //  FUNCTIO SHOPIFY ADD ITEM
                //-------------------------------------------------------------------------------------
                Shopify.addItem = function (variant_id, quantity, callback) {
                    var quantity = quantity || 1;
                    var params = {
                        type: "POST",
                        url: "/cart/add.js",
                        data: "quantity=" + quantity + "&id=" + variant_id,
                        dataType: "json",
                        success: function (line_item) {

                        },
                        error: function (XMLHttpRequest, textStatus) {
                            // Shopify.onError(XMLHttpRequest, textStatus);
                        },
                    };
                    jQuery.ajax(params);
                };

            }
        },
        error: function (t, e, i) { }
    });


    // var isInstteledT = await rsIsInstall();
    // console.log(isInstteledT)

});
//-------------------------------------------------------------------------------------
//  FUNCTION GET AND SET COOKIE
//-------------------------------------------------------------------------------------
function setCookie(t, e, i) {
    var n = new Date();
    n.setTime(n.getTime() + 24 * i * 60 * 60 * 1e3);
    var o = "expires=" + n.toUTCString();
    document.cookie = t + "=" + e + ";" + o + ";path=/";
}
function getCookie(t) {
    let e = {};
    return (
        document.cookie.split(";").forEach(function (t) {
            let [i, n] = t.split("=");
            e[i.trim()] = n;
        }),
        e[t]
    );
}



var originePrice = '';
$(document.body).on('click', '.plus-btn', function (e) {
    value = $("input[name=quantity]").val();
    $('#csRadio0').val(`dfq,${value},0,2`);
    value = parseInt(value) + 1;
    let price = $('.sale-price').data('price');
    let currency = $('.sale-price').data('currency');
    let tt_price = price * value;
    if( currency == 'EUR' ) {
        currency = '€';
    }
    if( currency == 'MAD' ) {
        currency = 'dh';
    }
    if( $('#ProductPrice').hasClass( "product-single__price" ) ) {
        let price_pp = $('#ProductPrice').attr('content');
        tt_price = price_pp * value;
        $('#ProductPrice').text( tt_price.toFixed(2) +' '+ currency );
    }
    
    let total = parseFloat($('.price-shipping').attr('data-shipping-price')) +  parseFloat(tt_price.toFixed(2));
    $(".price-sh-tt").html(total + ' ' + Shopify.currency.active);
    
    $('.sale-price, .money').text( tt_price.toFixed(2) +' '+ currency );
    $("input[name=quantity]").val(value);

});
$(document.body).on('click', '.minus-btn', function (e) {
    value = $("input[name=quantity]").val();
    $('#csRadio0').val(`dfq,${value}).val()},0,2`);
    let price = $('.sale-price').data('price');
    let currency = $('.sale-price').data('currency');
    if(value>1) {
        value = parseInt(value) - 1;
        $("input[name=quantity]").val(value);
        let tt_price = price * value;
        if( currency == 'EUR' ) {
            currency = '€';
        }
        if( currency == 'MAD' ) {
            currency = 'dh';
        }
        if( $('#ProductPrice').hasClass( "product-single__price" ) ) {
            let price_pp = $('#ProductPrice').attr('content');
            tt_price = price_pp * value;
            $('#ProductPrice').text( tt_price.toFixed(2) +' '+ currency );
        }

        let total = parseFloat($('.price-shipping').attr('data-shipping-price')) +  parseFloat(tt_price.toFixed(2));
        $(".price-sh-tt").html(total + ' ' + Shopify.currency.active);
        
        $('.sale-price, .money').text( tt_price.toFixed(2) +' '+ currency );
    }
 
});
$(document.body).on('change', 'input[name=quantity]', function (e) {
    $('#csRadio0').val(`dfq,${$("input[name=quantity]").val()},0,2`);
});
/*********************************added by Farid***************************************/

$(document.body).on('click', '.btn-left', function (e) {

    let scrleft = $('#scroller').scrollLeft();
    $('#scroller').animate({
        scrollLeft: scrleft - 200
    }, 800)
});
$(document.body).on('click', '.btn-right', function (e) {
    let scrleft = $('#scroller').scrollLeft();
    $('#scroller').animate({
        scrollLeft: scrleft + 200
    }, 800)
});
$( "#email" ).keyup(function() {
    if(!String($(this).val()).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                                                 )){
      $('#error-email').show();
    }else{
      $('#error-email').hide();
    }
 });
$(document.body).on('click', '.var-option', function (e) {
    let upsell = JSON.parse(getCookie('upsells'))[0];
    let option1 = $('.current_option_name0').text();
    let option2 = $('.current_option_name1').text();
    let option3 = $('.current_option_name2').text() === '' ? null : $('.current_option_name2').text();
    let variants = JSON.parse(localStorage.getItem('upsellProduct')).variants;
    let price = null;
    variants.forEach(variant => {
        if (variant.option1 === option1 && variant.option2 === option2 && variant.option3 === option3) {
            price = variant.price;
        }
    });

    if (price != null) {
        $('.new-price-up-sell').html(`${Number(price - (price * upsell.discount / 100)).toFixed(2)}<span>${' ' + Shopify.currency.active}</span>`);
        $('.old-price-up-sell').html(`${Number(price).toFixed(2)}<span>${' ' + Shopify.currency.active}</span>`);
    }


});

$(document.body).on('click', '.var-option0', function (e) {
    let currentValue = $(this).attr('data-value');
    let upsellProduct = JSON.parse(localStorage.getItem('upsellProduct'));
    let variants = upsellProduct.variants;
    let options = upsellProduct.options
    let optionValuesCheck = [];
    let var2default = ''
    let option2Variants = ''
    let var3default = ''
    let option3Variants = ''
    let iIndex = 0;
    let jIndex = 0;
    variants.forEach((variant, variantIndex) => {
        if (variant.option1 === currentValue && iIndex == 0 && variant.available) {
            if(variant.featured_image!=null){
                $('#current-upsell-img').attr('src',variant.featured_image.src);
                $('.upsell-img').removeClass('upsell-img-active')
            }
        }
    });
    if (options.length >= 2) {
        console.log('hello iption 2')
        variants.forEach((variant, variantIndex) => {
            if (!optionValuesCheck.includes(variant.option2)) {
                if (variant.option1 === currentValue && iIndex == 0 && variant.available) {
                    option2Variants += `<li class="active  var-option"><a href="#" class="var-option1" data-value="${variant.option2}">${variant.option2}</a></li>`
                    var2default = variant.option2;
                    optionValuesCheck.push(variant.option2);
                    iIndex++;
                    localStorage.setItem('upsellsVariantId', variant.id);
                    console.log()
                    if(variant.featured_image!=null){
                        $('#current-upsell-img').attr('src',variant.featured_image.src);
                        $('.upsell-img').removeClass('upsell-img-active')
                    }
                } else if (variant.option1 === currentValue && variant.available) {
                    option2Variants += `<li class="var-option"><a href="#" class="var-option1" data-value="${variant.option2}">${variant.option2}</a></li>`
                    optionValuesCheck.push(variant.option2);
                    localStorage.setItem('upsellsVariantId', variant.id);
                }

            }
        });
        $('.options1').html(option2Variants);
        $('.current_option_name1').text(var2default);
        if (options.length >= 3) {
            variants.forEach((variant, variantIndex) => {
                if (variant.option1 === currentValue && variant.option2 === var2default && jIndex == 0 && variant.available) {
                    option3Variants += `<li class="active  var-option"><a href="#" class="var-option2" data-value="${variant.option3}">${variant.option3}</a></li>`
                    var3default = variant.option3;
                    jIndex++;
                    localStorage.setItem('upsellsVariantId', variant.id);
                } else if (variant.option1 === currentValue && variant.option2 === var2default && variant.available) {
                    option3Variants += `<li class="var-option"><a href="#" class="var-option2" data-value="${variant.option3}">${variant.option3}</a></li>`
                    localStorage.setItem('upsellsVariantId', variant.id);
                }

            });
            $('.options2').html(option3Variants);
            $('.current_option_name2').text(var3default);
        }
    }else {

    }
});

$(document.body).on('click', '.var-option1', function (e) {
    let firstOption = $('.current_option_name0').text().trim();
    let currentValue = $(this).attr('data-value');
    let upsellProduct = JSON.parse(localStorage.getItem('upsellProduct'));
    let variants = upsellProduct.variants;
    let options = upsellProduct.options
    let optionValuesCheck = [];
    let var3default = ''
    let option3Variants = ''
    let jIndex = 0;
    variants.forEach((variant, variantIndex) => {
        if (variant.option1 === firstOption && variant.option2==currentValue) {
            localStorage.setItem('upsellsVariantId', variant.id);
        }
    });
    if (options.length >= 3) {
        variants.forEach((variant, variantIndex) => {
            if (!optionValuesCheck.includes(variant.option3)) {
                if (variant.option1 == firstOption && variant.option2 === currentValue && options[2].name === 'Color' && jIndex == 0) {
                    option3Variants += `<li class="active var-option"><a href="#" class="options-color var-option2" data-value="${variant.option3}" data-tooltip="${variant.option3}">${variant.option3}</a></li>`
                    var3default = variant.option3;
                    optionValuesCheck.push(variant.option3);
                    jIndex++;
                    localStorage.setItem('upsellsVariantId', variant.id);
                } else if (variant.option1 == firstOption && variant.option2 === currentValue && options[2].name === 'Color') {
                    option3Variants += `<li class="var-option"><a href="#" class="options-color var-option2" data-value="${variant.option3}" data-tooltip="${variant.option3}">${variant.option3}</a></li>`
                    optionValuesCheck.push(variant.option3);
                    localStorage.setItem('upsellsVariantId', variant.id);
                } else if (variant.option1 == firstOption && variant.option2 === currentValue && jIndex == 0) {
                    option3Variants += `<li class="active  var-option"><a href="#" class="var-option2" data-value="${variant.option3}">${variant.option3}</a></li>`
                    var3default = variant.option3;
                    optionValuesCheck.push(variant.option3);
                    jIndex++;
                    localStorage.setItem('upsellsVariantId', variant.id);
                } else if (variant.option1 == firstOption && variant.option2 === currentValue) {
                    option3Variants += `<li class="var-option"><a href="#" class="var-option2" data-value="${variant.option3}">${variant.option3}</a></li>`
                    optionValuesCheck.push(variant.option3);
                    localStorage.setItem('upsellsVariantId', variant.id);
                }
            }
        });

        $('.options2').html(option3Variants);
        $('.current_option_name2').text(var3default);
    }

});
$(document.body).on('click', '.var-option', function (e) {
    $(this).addClass('active').siblings().removeClass('active');
});
$(document.body).on('click', '.var-option0', function (e) {
    $('.current_option_name0').text($(this).attr('data-value'));
});

$(document.body).on('click', '.var-option1', function (e) {
    $('.current_option_name1').text($(this).attr('data-value'));
});

$(document.body).on('click', '.var-option2', function (e) {
    $('.current_option_name2').text($(this).attr('data-value'));
});

$(document.body).on('click', '.upsell-img', function (e) {
    $('.upsell-img').removeClass('upsell-img-active');
    $(this).addClass('upsell-img-active');
    $('#current-upsell-img').attr('src', $(this).attr('src'));
});
$(document.body).on('click', '#addToOrder', function (e) {
    let cookie = JSON.parse(getCookie("upsellsAndOrder"));
    let id_order_shopify = getCookie("id_order_shopify");
    let upsellsVariantId = localStorage.getItem("upsellsVariantId");
    let variants = [];
    for (let i = 0; i < 3; i++) {
        if ($(`.current_option_name${i}`).text().trim() !== '') {
            variants.push($(`.current_option_name${i}`).text().trim());
        }
    }
    let n = new FormData();
    n.append('image', $('#current-upsell-img').attr('src'));
    n.append('product', $('.upsell-product-title').text());
    n.append('price', $('.new-price-up-sell').text());
    n.append('oldPrice', $('.old-price-up-sell').text());
    n.append('store_id', parseInt(cookie.upsells[0].store_id));
    n.append('product_id', parseInt(cookie.upsells[0].product_up));
    n.append('order_id', parseInt(cookie.order_id));
    n.append('variants', JSON.stringify(variants));
    n.append('variant_id', upsellsVariantId);
    n.append('id_order_shopify', id_order_shopify);
    n.append('url', $('#productUrl').val());
    n.append("currency_conv", getCookie("currency_conv"));
    n.append("discount", $('#discount').val());
    $.ajax({
        url: window.admin + "/api/setupsell",
        data: n,
        type: "POST",
        cache: !1,
        contentType: !1,
        processData: !1,
        beforeSend: function () {
            $('.loading-upsell').show();
            $('.loading-upsell').show();
            $('#addToOrder').prop('disabled', true);
        },
        success: function (t) {
            localStorage.setItem('order_status_url', null);
            localStorage.setItem('order_status_url', t.order_status_url);
            let order_status_url = localStorage.getItem("order_status_url");
            if( order_status_url != "null"  ) {
                window.location.replace(order_status_url);
            } else {
                $('.loading-upsell').hide();
                $('.upsell-container').css('display','none').addClass('d-none');
                $('.page-head').css('display','block').removeClass('d-none');
                $('.modal-dialog').addClass('modal-dialog-thank');
                $('#addToOrder').prop('disabled', false);
            }
            Shopify.clear();
        },
        error: function (t, e, i) {
            $('.loading-upsell').hide();
            $('.upsell-container').css('display','none').addClass('d-none');
            $('.page-head').css('display','block').removeClass('d-none');
            $('.modal-dialog').addClass('modal-dialog-thank');
            Shopify.clear();
        },
    });
});
$(document.body).on('click', '#noThankYou', function (e) {
    $('.modal-dialog').addClass('modal-dialog-thank');
    $('.upsell-container').css('display','none').addClass('d-none');
    $('.page-head').css('display','block').removeClass('d-none');
    Shopify.clear();

});
$(".fermer-reviews").on('click', function (e) {
    $('#modalAddReview').fadeOut();
});
  
  
/*********************************added by RedOne***************************************/
(function () {
    const second = 1000,
        minute = second * 60,
        hour = minute * 60,
        day = hour * 24;
    var tremain ="&ctn";
    if(isNaN(tremain)) {
        tremain =5;
    }
    // console.log(tremain)
    var date;
    if (typeof (getCookie("date_cd")) === 'undefined') {
        date = new Date();
        setCookie("date_cd", date, 1);
    } else {
        int_date = Date.parse(getCookie("date_cd"));
        date = new Date(int_date);
    }
    date.setDate(date.getDate() + parseInt(tremain));
    let x = setInterval(function () {
        let now = new Date().getTime();
        // console.log(now);
        // console.log(date);
        let distance = parseInt(date.getTime()) - parseInt(now);
        // console.log(distance)
        $('.product-time .days').text(Math.floor(distance / (day)));
        $('.product-time .hours').text(Math.floor((distance % (day)) / (hour)));
        $('.product-time .minutes').text(Math.floor((distance % (hour)) / (minute)));
        $('.product-time .seconds').text(Math.floor((distance % (minute)) / second));
        //do something later when date is reached
        if (distance < 0) {
            clearInterval(x);
        }
    }, 0)
}());
// NAVIGATION TO TOP
$("a[href='#btn-style']").click(function () {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
});
// SHOW FIXED
$(window).scroll(function() {
    var b = $('.btn-sticky-order').first(),
        p = $('.tt-fixed-product-wrapper');
     var top = (b.offset() || { "top": NaN }).top;
      if(!isNaN(top)) {
      if ( $(window).scrollTop() > b.offset().top ) {
          p.css('display','flex');
      } else {
          p.css('display','none');
      }
    }
});


$('#show-review').click(function (e) {
    $(".modal-reviews").css("display", "grid");
});

$('.modal-reviews').click(function (e) {
    $(this).fadeOut();
});

$('.modal-reviews .modal-content').click(function (e) {
    e.stopPropagation();
});

// SHIPPING
$('#country').on('change',function(e) {
    e.preventDefault();
    let country = $(this).val();
    var cache = JSON.parse(localStorage.getItem("shipping"));
    $(".shipping-items-group, .shipping-detail").hide();
    let status = '';
    status += `<option value=""></option>`;
    let is_state = false;
    let is_rate = false;
    codeL = ''; 
  	$('.addtocart-js2').prop('disabled', true);
    $.each(cache, function(i, item) {
        if( country == i && i != "Rest of world" ) {
        item.forEach((item, index) => {
            item.forEach((item, index) => {
            is_state = true;
            status += `<option value="${item.state['id']}">${item.state['name']}</option>`;
            });
        })
        }
    });
    
    if(is_state == false) {
        $.each(cache, function(i, item) {
            if ( "Rest of world" == i ) {
                item.forEach((item, index) => {
                    item['rates'].forEach((item, index) => {
                        is_state = false;
                        is_rate = true;
                        codeL += `
                            <div class="item-cross-sell defaultCross">
                            <div class="form-check" dir="ltl">
                                <input class="form-check-input shipping_rate" data-rate="${item['id']}" data-price="${item['price']}" id="shipping_rate_${item['id']}" value="${item['id']}"  type="radio" name="shipping_rate">
                                <label class="form-check-label" for="shipping_rate_${item['id']}">${item['name']}  ${item['price']}</label>
                            </div>
                            </div>
                        `;
                    });
                })
            }
        });
    }
    // console.log(codeL)
    if( is_rate ) {
        // $(".shipping-items-group").html(codeL).show();
    } else {
        $(".shipping-items-group").html("").hide();
    }
    
    if(is_state) {
        // $("#state-shipping").html(status).show();
    } else {
        $("#state-shipping").html(status).hide();
    }

});

$(document).on("change", "#state-shipping", function (e) {
//$('#state-shipping').on('change',function(e) {
    e.preventDefault();
    var codeL = '';
    let state = $(this).val();
    var shipping = JSON.parse(localStorage.getItem("shipping"));
    let country = $('#country').find(":selected").text();
    let isOne = true;
    $("#state").val(state)
    if(shipping!=null){
        shipping.forEach((item, index) => {
            if( item.isOneCountry != 1 ) {
                isOne = false;
            }
        });
        if( shipping.length == 1 || isOne ) {
            country = shipping[0].country['name'];
        }
    }
    codeL = ''; 
    let status = '';
    let is_state = false;
    let is_rate = false;
    let converte            = getCookie("converte");
    let currency            = $('.currency-price').data('currency');
    let currencya           = getCookie("currency");
    $('#rate_shipping').val('');
    // let state = "";
    $('.shipping-detail').hide();
        $('.addtocart-js2').prop('disabled', true);
    codeL = '<div class="hr-crossel">'+ title_fees +'</div><div class="listing-form-check">';
    if(shipping!=null){
        shipping.forEach((item, index) => {
            if( item['country']['name'] == country ) {
                if( item['isAllStates'] == 0 ) {
                    item['states'].forEach((item, index) => {  
                    if( item.state != null ) {
                        if( item.state['id'] == state ) {
                            item['rates'].forEach((item, index) => {  
                                let pricee = item['price'];
                                if( item['price'] == 0 ) {
                                pricee = '';
                                }
                                //pricee = getItemFormatedPrice(pricee);
                                pricee = pricee.toFixed(2) + ' ' + Shopify.currency.active;
                                let check = '';        
                                if( index == 0 ) {
                                    check = 'checked';
                                    $('.addtocart-js2').prop('disabled', false);
                                    $('#rate_shipping').val( item['id'] );
                                    let pro_price = $('.sale-price').attr('data-price');
                                    let total = 0;
                                    if(pro_price) {
                                        currency = $('.sale-price').attr('data-currency');
                                        $('.price-shipping').text( parseFloat(item['price']).toFixed(2) + ' ' + currency ).attr('data-shipping-price', item['price']);
                                        $('.sale-price').text( parseFloat(pro_price).toFixed(2) +' '+currency);
                                        total = parseFloat(item['price']) + parseFloat(pro_price);
                                        $('.price-sh-tt').text( parseFloat(total).toFixed(2) +' '+ currency );
                                        $('.shipping-detail').removeClass('hide').show();
                                    }
                                }
                                codeL += `
                                    <div class="form-check form-check-${index}" dir="ltl">
                                        <input class="form-check-input shipping_rate" ${check} data-rate="${item['id']}" data-price="${item['price']}" id="shipping_rate_${item['id']}" value="${item['id']}"  type="radio" name="shipping_rate">
                                        <label class="form-check-label" for="shipping_rate_${item['id']}">
                                            <span class="label-text">
                                                ${item['name']} 
                                            </span>
                                            <span class="label-price">
                                                ${ pricee }
                                            </span>
                                        </label>
                                    </div>
                                `;
                                is_rate = true;
                            })
                        }
                    }
                    });
                }
            }
        });
    }

    if( is_rate ) {
        $('.shipping-sell-group').show();
        codeL += '</div>';
        $(".shipping-items-group").html(codeL).show();
    } else {
        $('.shipping-sell-group').hide();
        $(".shipping-items-group").html("").hide();
    }

});
    

// $('.shipping_rate').on('change', function() {
$(document).on("click", ".shipping_rate", function (event) {
    let price = $(this).data('price');
    let currency = Shopify.currency.active;
    if( currency == "MAD" ) {
        currency = "dh";
    }
    let pro_price = $('.sale-price').attr('data-price');
    let total = parseFloat(price)+ parseFloat(pro_price);
    $(".shipping-sell-group").show();
    $('.shipping-detail').removeClass('hide').show();

    let html = details_shipping_price(pro_price, price, total, currency);
    $('.tt-price-last').html( html );
    let id = $(this).val();
    localStorage.setItem( 'shipping_rate', id );
    if ($("#phone").val().length > 0 && $('#error-msg').text() === '') {
        $('.addtocart-js2').prop('disabled', false);
    }
});

function details_shipping_price(pro_price, price, total, currency) {
    var html = `
        <div class="tt-label-price">
            <span class="label-price"> ${ title_product } </span>
            <span id="sale-price" class="sale-price" data-price="${ pro_price }" data-currency="${ currency }">${ pro_price } ${ currency }</span>
        </div>
        <div class="tt-label-price shipping-detail" style="display: inline-block;">
            <span class="label-price"> ${ title_shipping } </span>
            <span class="price-shipping" data-shipping-price="${ price }">${ price.toFixed(2) } ${ currency }</span>
        </div>
        <div class="tt-label-price shipping-detail" style="display: inline-block;">
            <span class="label-price"> ${ title_total } </span>
            <span class="price-sh-tt">${total.toFixed(2)} ${currency}</span>
        </div>
    `;
    return html;

}

$('.addtocart-card-only').on('click',async function (e) {
    e.preventDefault();
    await addItemToCart(variant, 1, "1", "Months");
    console.log('rr');
    window.location.replace("https://www.lockerfoot.com/cart");
});

$('body').on('click', '.tt-fixed-product-wrapper .addtocart-js', function (e) {
    e.preventDefault();
    $("html, body").animate({ 
      scrollTop: $(".form-quick-form").offset().top
    }, "slow");
});

$(document.body).on('change','.single-option-selector',function (e) {
    var optVal= $('select[name="id"] option:selected').val();
    if(single_product!=null) {
        $.each(single_product.variants, function (t, e) {
            variant = e.id;
            if( variant == optVal ) {
                let currency = Shopify.currency.active;
                if( currency == "COP" ) {
                    currency = "$";
                } else if(currency == "MAD") {
                    currency = "dh";
                }
                $('#ProductPrice-product-template').text(e.price/100 +' '+currency);
                $('.sale-price').text( parseFloat((e.price/100), 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + ' '+currency ).attr('data-price', (e.price/100).toFixed(2)).attr('data-currency', currency);
            }
        });
    }
});
$( window ).on( "load", function() {
    if( $('#landing_page').val() == "Isexist" ) {
        $('.btn-sticky-order').removeClass('.addtocart-js2').addClass('codmonster-landing-page');
    }
});
// *********************************
// *********************************
// *********LANDING PAGE
// *********************************
// *********************************
$('.codmonster-landing-page').prop('disabled', true);
$('#phone').focusout( function (event) {
  event.preventDefault();
  if( $('#phone').val() != '' ) {
    $('.codmonster-landing-page').prop('disabled', false);
  }
});
$(document).on("click", '.codmonster-landing-page', function (event) {
    event.preventDefault();
    console.log('landing');
    let id_variant = $("[name=id]").val();
    if( id_variant == undefined || id_variant == "" ) {
        id_variant = $(".zn-data").attr('data-variant'); 
        if( id_variant == undefined || id_variant == "" ) {
            id_variant = $(".sc-gXRojI").attr('data-default-variant');
            console.log( id_variant )
        } 
        if( id_variant == undefined || id_variant == "") {
            console.log( "id_variant" )
            id_variant = $(".sc-gXRojI").attr('data-product-id');
            if(id_variant) {
                id_variant  = window.__pageflyProducts[id_variant].variants[0].id;
            }
        }
        if( id_variant == undefined || id_variant == "" ) {
            id_variant  = $('.pf-variant-select').find("option:first-child").val();
        }
    }
    var params = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=1&id=" + id_variant,
        dataType: "json",
        success: function (line_item) {
            var i = new FormData();
            var htmlcart = "";
            jQuery.getJSON("/cart.js", function (t) {
                var tttt = t;
                var n = new FormData();
                let variant_id = t['items'][0].id;
                n.append("form_type", 'product');
                n.append("id", variant_id);
                n.append("quantity", t['items'][0].quantity);
                n.append("name", $("#name").val());
                n.append("phone", $("#phone").val());
                n.append("note", ($("#note").val()?$("#note").val():""));
                n.append("city", ($("#city").val()?$("#city").val():""));
                n.append("state", ($("#state").val()?$("#state").val():""));
                n.append("zipcode", ($("#zipcode").val()?$("#zipcode").val():""));
                n.append("address",( $("#address").val()?$("#address").val():""));
                n.append("suffex", ($('.iti__selected-flag').attr('title')?$('.iti__selected-flag').attr('title'):"") );
                n.append("up_sell", "0,"+t['items'][0].quantity+",0,2");
                n.append("shop", Shopify.shop);
                n.append("currentOrderId", getCookie("currentOrderId")),
                n.append("data", JSON.stringify(t));
                $(".loader").show();
                setTimeout(async function () {
                    $.ajax({
                        url: window.admin + "/api/order",
                        data: n,
                        type: "POST",
                        cache: !1,
                        contentType: !1,
                        processData: !1,
                        beforeSend: function () {
                            $(".loader").show();

                            (typeof fbq === "function") ? fbq('track', 'Purchase', {
                                currency: Shopify.currency.active,
                                value: tttt['items'][0].price / 100
                            },{eventID:new Date().getTime()}) : null;
                            
                            (typeof snaptr === "function") ? snaptr('track', 'PURCHASE', {
                                'currency': Shopify.currency.active == 'OMR' ? 'USD' : Shopify.currency.active,
                                'price': Shopify.currency.active == 'OMR' ? (tttt['items'][0].price / 100 * 2.6).toFixed(2) : (tttt['items'][0].price / 100).toFixed(2),
                                'item_category': '',
                                'item_ids': ''
                            }) : null;

                            (typeof ttq == "object") ?
                                ttq.track('CompletePayment',{
                                    content_type:'product',
                                    description: variant_id,
                                    content_id: $("#phone").val(),
                                    quantity: 1,
                                    price: tttt['items'][0].price/ 100,
                                    value: tttt['items'][0].price/ 100,
                                    currency: Shopify.currency.active})
                            : null;

                        },
                        success: function (t) {
                            
                            $('#phone').val('');

                            $(".btn-quick-form").prop("disabled", !1);

                            Shopify.clear();

                            setCookie("order_id", null, 1), 
                            setCookie("upsells", null, 1);

                            localStorage.setItem('order_status_url', null);
                            localStorage.setItem('order_status_url', t.order_status_url);

                            let order_status_url = localStorage.getItem("order_status_url");
                            
                            if( order_status_url != "null"  ) {
                                window.location.replace(order_status_url);
                            } else {                
                                $(".loader").hide();
                                $("#modalThankYouPage").css('display', 'flex');
                                $(".msg-promo").text("");
                                $('.upsell-container').addClass('d-none');
                                $('.modal-dialog').addClass('modal-dialog-thank');
                                return false;
                            }

                        },
                        error: function (t, e, i) {
                            $("#quick-form .add-to-cart").prop("disabled", !1), $("#loading-atc").hide();
                        }
                    });
                }, 300);
            });
        },
        error: function (XMLHttpRequest, textStatus) { },
    };
    jQuery.ajax(params);
});

    
function remplirCountry() {
  
    var countryList = [
        "Afghanistan",
        "Åland Islands",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas (the)",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia (Plurinational State of)",
        "Bonaire, Sint Eustatius and Saba",
        "Bosnia and Herzegovina",
        "Botswana",
        "Bouvet Island",
        "Brazil",
        "British Indian Ocean Territory (the)",
        "Brunei Darussalam",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Cabo Verde",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cayman Islands (the)",
        "Central African Republic (the)",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands (the)",
        "Colombia",
        "Comoros (the)",
        "Congo (the Democratic Republic of the)",
        "Congo (the)",
        "Cook Islands (the)",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Curaçao",
        "Cyprus",
        "Czechia",
        "Côte d'Ivoire",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic (the)",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Eswatini",
        "Ethiopia",
        "Falkland Islands (the) [Malvinas]",
        "Faroe Islands (the)",
        "Fiji",
        "Finland",
        "France",
        "French Guiana",
        "French Polynesia",
        "French Southern Territories (the)",
        "Gabon",
        "Gambia (the)",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guadeloupe",
        "Guam",
        "Guatemala",
        "Guernsey",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Heard Island and McDonald Islands",
        "Holy See (the)",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran (Islamic Republic of)",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Jamaica",
        "Japan",
        "Jersey",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Korea (the Democratic People's Republic of)",
        "Korea (the Republic of)",
        "Kuwait",
        "Kyrgyzstan",
        "Lao People's Democratic Republic (the)",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macao",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands (the)",
        "Martinique",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia (Federated States of)",
        "Moldova (the Republic of)",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Myanmar",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands (the)",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger (the)",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands (the)",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Palestine, State of",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines (the)",
        "Pitcairn",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Republic of North Macedonia",
        "Romania",
        "Russian Federation (the)",
        "Rwanda",
        "Réunion",
        "Saint Barthélemy",
        "Saint Helena, Ascension and Tristan da Cunha",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin (French part)",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Sint Maarten (Dutch part)",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Georgia and the South Sandwich Islands",
        "South Sudan",
        "Spain",
        "Sri Lanka",
        "Sudan (the)",
        "Suriname",
        "Svalbard and Jan Mayen",
        "Sweden",
        "Switzerland",
        "Syrian Arab Republic",
        "Taiwan (Province of China)",
        "Tajikistan",
        "Tanzania, United Republic of",
        "Thailand",
        "Timor-Leste",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands (the)",
        "Tuvalu",
        "Uganda",
        "Ukraine",
        "United Arab Emirates (the)",
        "United Kingdom of Great Britain and Northern Ireland (the)",
        "United States Minor Outlying Islands (the)",
        "United States of America (the)",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela (Bolivarian Republic of)",
        "Viet Nam",
        "Virgin Islands (British)",
        "Virgin Islands (U.S.)",
        "Wallis and Futuna",
        "Western Sahara",
        "Yemen",
        "Zambia",
        "Zimbabwe"
    ];
    
    if( $('html').attr('lang') == "ar" ) {
        var str = "<option value=''>البلد</option>";
    } else {
        var str = "<option value=''>Select Country</option>";
    }
    $.each(countryList, function (t, e) {
        str += "<option value='" + e + "'>" + e + "</option>";
    });
    $('#country').html(str);    
}

$.get("https://ipinfo.io", function(response) {
    setCookie("country_iso", response.country, 1)
}, "jsonp");

console.log('2.0.1') 


// *********************************
// *********************************
// ********* COUPON CODE
// *********************************
// *********************************
$(document).on("click", '#verifier-coupon', function (event) {
    event.preventDefault();

    var price = 0;
    meta.product.variants.forEach(element => {
        if (element.id == $("#input_variant").val()) {
            price = element.price/100;
        }
    });
    
    var n = new FormData();
    n.append("shop", Shopify.shop);
    n.append("product_id", meta.product.id);
    n.append("id", meta.product.id);
    n.append("code",  ($("#coupon_code").val()?$("#coupon_code").val():"") );

    $.ajax({
        url: window.admin + "/api/coupons",
        data: n,
        type: "POST",
        cache: !1,
        contentType: !1,
        processData: !1,
        beforeSend: function () { 
        },
        success: function (t) {
            if(t.status==1) {
                $('.error-coupon').hide();
                let e = 0;
                if (typeof price !== "undefined") {
                    let currencyIno = $('.sale-price').attr('data-currency');

                    setCookie("coupon_value", t.coupon['value'], 1);
                    setCookie("coupon_type", t.coupon['type'], 1);
                    setCookie("coupon_id", t.coupon['id'], 1);

                    if(t.coupon['type']==1) {
                        e = (parseFloat(price) - ((t.coupon['value']*parseFloat(price))));
                    } else if(t.coupon['type']==2) {
                        e = (parseFloat(price) - t.coupon['value']);
                    }
                    let shipping_price = $('.price-shipping').attr('data-shipping-price');
                    $(".sale-price").html( (e).toFixed(2) + ' ' + currencyIno ).attr('data-price',e);
                    $(".new-price").html( (e).toFixed(2) + ' ' + currencyIno ).attr('data-price',e);
                    $('.popup-price').html( (e).toFixed(2) );
                    let tt_tt = (parseFloat(e.toFixed(2)) + parseFloat(shipping_price) ).toFixed(2);
                    $('.price-sh-tt').text( tt_tt + ' '+ currencyIno );
                }
            } else {
                $('.error-coupon').text('Coupon invalid').css('display', 'block');
            } 
        },
        error: function (t, e, i) {
        }
    });
});


// *********************************
// *********************************
// ********* START CHECKOUT BUTTON
// *********************************
// *********************************

$(document).ready(function(){
    $("#my-modal-cart").html(`
        
                <div class="form-quick-form" lang="en" style="border: 2px solid #8908da;">
                    <p class="form-headline text-center" style="color: #191718 !important; font-size: 14px; font-weight: 600;"> 
                        Please fill this form to order this item!
                    </p> 
                    <input id="input_variant" type="hidden" value="" class="form-control">
                     
                <div class="inputGroup" data="1">
                    <input id="name" type="text" name="name"  placeholder="full name" value="" class="form-control-rd" required>
                    <span class="inputBar"></span>
                    <span id="error-name" class="error-msg" style="color: red;display: none; "></span>
                </div>
            
                <div class="inputGroup" data="2">
                    <input id="phone" type="tel" name="phone" placeholder="Phone number" value="" class="form-control-rd phone" required>
                    <span class="inputBar"></span>
                    <span id="error-msg" class="phone-error " style="color: red; display: none;"></span>
                    <span id="phone-error" style="color: red; display: none;"></span>
                </div>
            
                <div class="inputGroup" data="3">
                    <input id="city" type="text" name="city"  placeholder="City"  value="" class="form-control-rd" required>
                    <span class="inputBar"></span>
                    <span id="error-city" class="error-msg"   style="color: red;display: none;"></span>
                </div>
            
                <div class="inputGroup" data="4">
                    <input id="address" name="address"  placeholder="Address"  class="form-control-rd" rows="3" id="textareaMessage" required>
                    <span class="inputBar"></span>
                    <span id="error-address" class="error-msg"  style="color: red;display: none;"></span>
                </div>
            

                    <div class="shipping-sell-group-country">
                        <select name="country" id="country"></select>
                        <select class="hide" name="state-shipping" id="state-shipping"></select>
                    </div> 

                    <div class="cross-sell-group"></div>
                    <div class="shipping-sell-group">
                        <div class="shipping-items-group">
                        </div>
                        <input type="hidden" value="" id="rate_shipping" name="rate_shipping">
                    </div>

                    
            <div class="tt-price tt-price-last">
                <div class="tt-label-price">
                    <span class="label-price"></span>
                    <span class="sale-price" data-currency="" style="color: #8908da;"  >
                    </span>
                </div>
                <div class="tt-label-price shipping-detail hide">
                    <span class="label-price"></span>
                    <span class="price-shipping" data-shipping-price="0" style="color: #8908da;" ></span>
                </div>
                <div class="tt-label-price shipping-detail hide">
                    <span class="label-price"></span>
                    <span class="price-sh-tt" style="color: #8908da;" ></span>
                </div>
            </div>
        
                    
                    <button 
                        type="submit" 
                        class="btn btn-sticky-order btn-lg button addtocart-js2  shaking-btn" 
                        style="background: #8908da; color: #ffffff;" 
                        >
                            <div class="loader" style="display:none;"></div>
                            Buy now
                    </button>
                    
                    
                </div>
            
    `);
    $("input[name='checkout'], #checkout").on('click', function(e) {
        e.preventDefault();
    
        $('.btn-sticky-order').removeClass('addtocart-js2').addClass('btn-cart-checkout');
        $('#my-modal-cart').css("display", "block");
        $('#my-modal-cart').show();

        let html = '';
        jQuery.getJSON("/cart.js", function (t) {
            let pricett = 0;
            t['items'].forEach((element)=>{
                let option = '';
                element['options_with_values'].forEach((el,i)=>{
                    if( i!=0 ) {
                        option = '/';
                    }
                    option = `
                        ${el['name']} : ${el['value']}
                    `;
                });
                pricett = pricett + parseFloat( element['final_line_price']/100 )
                html += `
                    <div class="unit-items" id="item_${element['id']}">
                        <div class="img-cont">  
                            <img src="${element['image']}" alt="">           
                        </div>   
                        <div class="body-cont">
                            <h4 class="title-popup"> ${ element['product_title'] } </h4>
                            <div class="qty-price">
                                <span class="variant-popup"> ${option} </span>
                                <span class="price-popup">${ element['quantity'] } X ${ element['price']/100 } ${ Shopify.currency.active } </span>
                            </div>
                            <button id="remove-item" data-id="${element['id']}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20px" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 27.965 27.965" style="enable-background:new 0 0 27.965 27.965;" xml:space="preserve"><g><g id="c142_x"><path d="M13.98,0C6.259,0,0,6.261,0,13.983c0,7.721,6.259,13.982,13.98,13.982c7.725,0,13.985-6.262,13.985-13.982    C27.965,6.261,21.705,0,13.98,0z M19.992,17.769l-2.227,2.224c0,0-3.523-3.78-3.786-3.78c-0.259,0-3.783,3.78-3.783,3.78    l-2.228-2.224c0,0,3.784-3.472,3.784-3.781c0-0.314-3.784-3.787-3.784-3.787l2.228-2.229c0,0,3.553,3.782,3.783,3.782 c0.232,0,3.786-3.782,3.786-3.782l2.227,2.229c0,0-3.785,3.523-3.785,3.787C16.207,14.239,19.992,17.769,19.992,17.769z"/></g><g id="Capa_1_104_"></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                            </button>
                        </div>   
                    </div> 
                `;
            })
            $('.list-items-codmonster-cart').html(html);
            $('.btn-sticky-order').removeClass('.addtocart-js2');
            $('.sale-price').text( parseFloat(pricett, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString() + ' '+ Shopify.currency.active ).attr('data-price', (pricett).toFixed(2)).attr('data-currency', Shopify.currency.active)
        });
    });

    $(document).on("click", '.btn-cart-checkout', function (event) {
        event.preventDefault();

        setCookie("coupon_type", null, 1);
        setCookie("order_id", null, 1); 
        setCookie("currency_conv", null, 1); 
        setCookie("currentOrderId", null, 1); 
        setCookie("id_order_shopify", null, 1); 
        
        jQuery.getJSON("/cart.js", function (t) {
            var n = new FormData();
            let variant_id = t['items'][0].id;
            n.append("form_type", 'product');
            n.append("id", variant_id);
            n.append("quantity", t['items'][0].quantity);
            n.append("name", $("#name").val());
            n.append("phone", $("#phone").val());
            n.append("note", ($("#note").val()?$("#note").val():""));
            n.append("city", ($("#city").val()?$("#city").val():""));
            n.append("state", ($("#state").val()?$("#state").val():""));
            n.append("zipcode", ($("#zipcode").val()?$("#zipcode").val():""));
            n.append("address",( $("#address").val()?$("#address").val():""));
            n.append("suffex", ($('.iti__selected-flag').attr('title')?$('.iti__selected-flag').attr('title'):"") );
            n.append("up_sell", "0,"+t['items'][0].quantity+",0,2");
            n.append("shop", Shopify.shop);
            n.append("currentOrderId", getCookie("currentOrderId")),
            n.append("data", JSON.stringify(t));
            $(".loader").show();
            setTimeout(async function () {
                $.ajax({
                    url: window.admin + "/api/order",
                    data: n,
                    type: "POST",
                    cache: !1,
                    contentType: !1,
                    processData: !1,
                    beforeSend: function () {
                        $(".loader").show();
                    },
                    success: function (t) {
                        $('#phone').val('');
                        $(".btn-quick-form").prop("disabled", !1);
                        Shopify.clear();
                        setCookie("order_id", null, 1), 
                        setCookie("upsells", null, 1);
                        t.order_status_url = null;
                        let order_status_url = localStorage.getItem("order_status_url");
                        $(".loader").hide();
                        $("#modalThankYouPage").css('display', 'flex');
                        $("#modalThankYouPage").css('visibility', 'visible');
                        $(".msg-promo").text("");
                        $('.upsell-container').addClass('d-none');
                        $('.modal-dialog').addClass('modal-dialog-thank');
                        return false;
                    },
                    error: function (t, e, i) {
                        $("#quick-form .add-to-cart").prop("disabled", !1), $("#loading-atc").hide();
                    }
                });
            }, 300);
        });
    });
});

// *********************************
// *********************************
// ********* END CHECKOUT BUTTON
// *********************************
// *********************************


$(document).on("click", '.btn-codmonster-checkout', function (event) {
    event.preventDefault();
    let id_variant = $("[name=id]").val();
    var params = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=1&id=" + id_variant,
        dataType: "json",
        success: function (line_item) {
            console.log(line_item)
            window.location.replace("http://"+Shopify.shop+"/checkout");
        },
        error: function (XMLHttpRequest, textStatus) { },
    };
    jQuery.ajax(params);
});


$(document).on("click", '.js-mobile-nav-toggle', function (event) {
    event.preventDefault();
    window.stop();
  });
  